import style from './geometry.module.css'
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    balanceAtom,
    // groupInfoAtom,
    // logInfoAtom,
    modalObjAtom,
    openPaymentInfoAtom,
    rodinGenPipeline,
    rodinHistoryStatus,
    rodinModalLoadingAtom,
    rodinUploadedImages, setGenerateAtom,
    showSubscribeAtom,
    subscriptionsInfoAtom,
    taskDetailAtom,
    optionOpenAtom,
    logInfoAtom,
    textureCacheAtom,
    optionModeCloseAtom,
    optionModeRestAtom,
    optionSharpAtom,
    rodinMeshOptionAtom
} from "../../../../../store";
import { getTaskDetail, getTaskSettings, rodinConfirm, rodinHistory, rodinUpdate, updatePreference } from "../../../../../utils/net";
import { useTips } from "../../../../../common/GlobalTips";
import { addAndSubtract, fetchObjectToLocalURL, base64ToPos, pos2Base64 } from '../../../../../utils/format';
import { AiOutlineCheck } from 'react-icons/ai';
import { fetchSettings, getCurrentUserTotalRedoCount, startFakeProgressBar, doneFakeProgressBar } from "../../utils";
import { trackEvent } from '../../../../../utils/trackEvent'
import { History } from "../history"
import { conditionMapping, STAGE_ENUM } from "../../interface";
import { WeightSelector } from "../weightSelector";
import { ChangeConfirmTip } from "../changeConfirmTip";
import { SymmetricalTip } from "../symmetricalTip";
import { WaitingProgress } from "../progressBar";
import { RedoTips } from '../../../../newRodin/components/ShakeTips';
import Opcheck from './assets/checked.png'
import Opicon from './assets/opicon.png'
import OpiconIn from './assets/opiconin.png'
import Ophover from './assets/ophover.png'
import quadswitchIcon from './assets/quadswitch.png';
import { driver } from 'driver.js';
import * as Sentry from "@sentry/react";
import Option from '../Option';
import { useRefreshInfo, useWebSocket } from '../../../../../utils/hooks';
import { Annotation } from '../Annotation'
import editor from '../../assets/editor.png'
import { useTranslation } from "react-i18next";
import bboxicon from '../../assets/bboxicon.svg'
import boudingbox from '../../assets/boudingbox.png'
import voxel from '../../assets/voxel.png'
import pointcloud from '../../assets/pointcloud.png'
import taicon from './assets/taicon.png'
import tacheckicon from './assets/tacheckicon.png'
import meshcheckIcon from './assets/meshcheck.png'
import ultracheckIcon from './assets/ultracheck.png'
import rawcheckIcon from './assets/rawcheck.png'
import ThreeJSOverlay from './threejsoverlay';
import { AiOutlineClear } from "react-icons/ai";
import confirmedIcon from './assets/confirmed.png'
import backarrow from './assets/backarrow.png'
import delete_default from './assets/delete_default.svg'
import delete_hover from './assets/delete_hover.svg'

// import resetFront from '../../../../newRodin/components/ModelPresets/assets/resetFront.png'
import ThreeController from '../../../../newRodin/components/ModelPresets/scence';
// import sculptIcon from '../../../../newRodin/components/ModelPresets/assets/sculptIcon.png';

import { PermissionContext } from "../../../../../utils/context";
import Restricted from "../../../../../utils/restricted";
import { controllerInfoAtom } from '../../../../../store/rodin';
import { openDB } from 'idb';
import { useModal } from '../../../../../common/CommonModal';
import { directionMap, MODE_ARRAY, SAMPLING_ARRAY } from '../../../../../utils/map';

import xdirect from '../../../../newRodin/components/ModelPresets/assets/xdirect.svg'
import ydirect from '../../../../newRodin/components/ModelPresets/assets/ydirect.svg'
import zdirect from '../../../../newRodin/components/ModelPresets/assets/zdirect.svg'
import defaultDirect from '../../../../newRodin/components/ModelPresets/assets/direct.svg'
import symmetric_default from './assets/symmetric_default.png'
import symmetric_active from './assets/symmetric_active.png'
import Svg from '../../../../../common/Svg';
import ConditionRange from '../../../../../common/ConditionRange';
import DraggableInput from '../../../../../common/DragableInput';
import ReactGA from "react-ga4";


const defaultMeshParameters = {
    'bbox': {
        status: true,
        name: 'Bounding Box',
        icon: boudingbox,
        confirmed: false,
        params: [100, 100, 100, 1],
        pos: { x: 100, y: 100, z: 100 },
    },
    'voxel': {
        status: true,
        name: 'Voxel',
        icon: voxel,
        confirmed: false,
        params: [],
        pos: [],
        voxel_condition_cfg: true,
        voxel_condition_weight: 1.00,
        wlhparams: { x: 1, y: 1, z: 1 }
    },
    'pointCloud': {
        status: true,
        name: 'Point Cloud',
        icon: pointcloud,
        confirmed: false,
        params: [],
        pos: [],
        wlhparams: { x: 1, y: 1, z: 1 },
        pcd_condition_uncertainty: 0.010
    }
}

const defalutAdvOption = {
    'enable': {
        status: false
    },
    'seed': {
        value: -1
    },
    'rest': {
        value: false
    },
    'sharp': {
        value: 0
    },
    'cfg': {
        value: 10
    },
    'step': {
        value: 50
    },
    'negative_prompt': {
        value: false
    }
}

const promptList = {
    'Sharp': 'Detailed',
    'T/A Pose': 'T/A Pose',
}

const globalTimeStamp = process.env.REACT_APP_GLOBAL_TIMESTAMP //TODO:redo和Confirm是否可以点击

const GeometryGeneration = React.forwardRef(({ bodyRef, isMtlGeneratingRef }, ref) => {
    const balance = useRecoilValue(balanceAtom);
    const [isQueued, setIsQueued] = useState(false)
    const [taskDetail, setTaskDetail] = useRecoilState(taskDetailAtom);
    const [rodinMeshOption, setRodinMeshOption] = useRecoilState(rodinMeshOptionAtom)
    const [check, setCheck] = useState(true)
    const [stage, setStage] = useState(STAGE_ENUM.INIT)
    const [preChosenList, setPreChosenList] = useState([])
    const [chosenList, setChosenList] = useState([]);
    const [currentPolygonsIndex, setCurrentPolygonsIndex] = useState(2);
    const [prePolygonsIndex, setPrePolygonsIndex] = useState(2)
    const [rawCheck, setRawCheck] = useState(false)
    const [generatePercentage, setGeneratePercentage] = useState(0);
    //const userPermission= useRecoilValue(userPermissionAtom);
    const [redoCount, setRedoCount] = useState(0);
    const [promptText, setPromptText] = useState('');
    const [viewWeights, setViewWeights] = useState(false);
    const [selectorHover, setSelectorHover] = useState(false);
    const [directDragging, setDirectDragging] = useState(false);
    const initImageModeRef = useRef(false)
    const [, setWeights] = useState({});
    const [presetPrompts, setPresetPrompts] = useState([])
    const presetPromptsRef = useRef(presetPrompts);
    const [pointerArr, setPointerArr] = useState([0, 71.2, 142.4, 223.6, 284.8, 356]);
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const setDefaultImageURLs = useSetRecoilState(rodinUploadedImages);
    const [genPipeline, setGenPipeline] = useRecoilState(rodinGenPipeline);
    const currentViewingHistory = useRef(null)
    const [currentVersion, setCurrentVersion] = useState('latest')
    const [showSubLinkTip, setShowSubLinkTip] = useState(false)
    const [showOptSubLinkTip, setShowOptSubLinkTip] = useState(false)
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    const setRodinModalLoading = useSetRecoilState(rodinModalLoadingAtom)
    const [historyStatus, setHistoryStatus] = useRecoilState(rodinHistoryStatus)
    const [currentPreviewImage, setCurrentPreviewImage] = useState(false);
    const [optionOpen, setOptionOpen] = useRecoilState(optionOpenAtom)
    const [optionChange, setOptionChange] = useState(false)
    const [optionHover, setOptionHover] = useState(false)
    const uuid = genPipeline.taskInfo.data;
    const tip = useTips()
    const isDone = stage === STAGE_ENUM.DONE || stage === STAGE_ENUM.INIT || !genPipeline?.geoPreviewLoading?.status
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const { t } = useTranslation();
    const [confirmBtnInfo, setComfirmBtnInfo] = useState(t('BUTTON_SMALL_GEO_CONFIRM'))
    const [remaingShow, setRemaingShow] = useState(true)
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    // const logInfo = useRecoilValue(logInfoAtom);
    const { refreshInfo } = useRefreshInfo()
    // const groupInfo = useRecoilValue(groupInfoAtom);
    const [checkHyper, setCheckHyper] = useState(false)
    const { connect, query, disconnect, onMessage, setReconnectAttempts } = useWebSocket('/scheduler_socket');
    const setKeepRodinBoard = useSetRecoilState(setGenerateAtom)
    const [presetSymm, setPresetSymm] = useState([false, false])
    const [selectedDirection, setSelectedDirection] = useState(Array(5).fill("?"));
    const [meshParameters, setMeshParameters] = useState(defaultMeshParameters)
    const [advOption, setAdvOption] = useState(defalutAdvOption)
    const meshValues = Object.values(meshParameters)
    const meshKeys = Object.keys(meshParameters)

    const boundingBoxRef = useRef(null)
    const threeController = useRef(null)
    const [activeIndex, setActiveIndex] = useState(0)
    const [openThreeBoxSelector, setOpenThreeBoxSelector] = useState(false)
    const [loading, setLoading] = useState(false)
    const bboxRefArr = [useRef(null), useRef(null), useRef(null)]
    const bboxConfirmedRefArr = [useRef(null), useRef(null), useRef(null)]
    const [dragging, setDragging] = useState(false);
    const [fileDropHover, setFileDropHover] = useState(false);
    const [openQuadSwitch, setOpenQuadSwitch] = useState(false);
    const [controllerInfo, setControllerInfo] = useRecoilState(controllerInfoAtom);
    const [, setOptionModeClose] = useRecoilState(optionModeCloseAtom)
    const [optionModeRest, setOptionModeRest] = useRecoilState(optionModeRestAtom)
    const [optionSharp, setOptionSharp] = useRecoilState(optionSharpAtom)
    const fileInputRef = useRef(null)
    const boundingWrapperRef = useRef(null)
    const comfirmedIconRef = useRef(null)
    const optSubLinkTipRef = useRef(null)
    const xscrollRef = useRef(null)
    const taskTimeRef = useRef(null)
    const taskTimeValueRef = useRef(0)
    const [conditionReady, setConditionReady] = useState({
        self: false,
        other: false
    })
    const [openThreeWrapper, setOpenThreeWrapper] = useState({
        status: false,
        left: 0,
        top: 0
    })
    const [samplingVal, setSamplingVal] = useState(2);
    const [rangeDragging, setRangeDragging] = useState(false);
    const [openRange, setOpenRange] = useState(false);
    const [voxelScale, setVoxelScale] = useState(meshValues[1]?.voxel_condition_weight);
    const [voxelMode, setVoxelMode] = useState(meshValues[1]?.voxel_condition_cfg);
    const [pcdUncertainty, setPcdUncertainty] = useState(meshValues[2]?.pcd_condition_uncertainty);
    const { openModal, closeModal } = useModal();
    const textureCache = useRecoilValue(textureCacheAtom);
    const { isAllowedTo, isCreatorOrAbove } = useContext(PermissionContext);
    const [directionAnimation,] = useState(false);
    const [showDirectRange, setShowDirectRange] = useState(false);
    const [openDirectWrapper, setOpenDirectWrapper] = useState(false);
    const showDirectRangeRef = useRef(showDirectRange);
    const [directionIndex, setDirectionIndex] = useState(-1);
    const [sliderValue, setSliderValue] = useState([0, 0, 0]);
    const [voxelSymmetric, setVoxelSymmetric] = useState(false);
    const [taCheck, setTACheck] = useState(false)
    const [simplifyCheck, setSimplifyCheck] = useState(true)
    const [smoothCheck, setSmoothCheck] = useState(false)
    const [asymmetryCheck, setAsymmetryCheck] = useState(false);
    const directWrapperRef = useRef(null);
    const [directionWrapperCloseFlag, setDirectionWrapperCloseFlag] = useState(true);
    const [updated, setUpdated] = useState(false);
    const [noModel, setNoModel] = useState(true);
    const symmetricRef = useRef(null);
    const showSubLinkTipRef = useRef(null)
    const proCheckRef = useRef(null)
    const [openProCheck,setOpenProCheck] = useState(false)
    const [proChange, setProChange] = useState(false)
    const isCreator = ['Creator', 'Business', 'Enterprise'].includes(subscriptionsInfo.plan_level);
    const svgArray = [
        {
            src: defaultDirect,
        },
        {
            src: xdirect,
            show: false
        },
        {
            src: ydirect,
            show: false
        },
        {
            src: zdirect,
            show: false
        }
    ]
    const openThreeBoxSelectortimerRef = useRef(null)
    const swiperRef = useRef(null);
    const queryIntervalRef = useRef(null);

    useEffect(() => {
        const updateMeshOption = (newMeshOption) => {
            const qualityMap = ['extra-low', "low", "medium", "high"]
            if (newMeshOption.mesh_export_type === 'Raw') {
                setRawCheck(true)
                setCurrentPolygonsIndex(-2)
                setPrePolygonsIndex(qualityMap.indexOf(newMeshOption.quality))
            } else if (newMeshOption.mesh_export_type === 'Quad') {
                setCurrentPolygonsIndex(qualityMap.indexOf(newMeshOption.quality))
            }
            if (newMeshOption.mesh_smooth) {
                setSmoothCheck(true)
            }
            if (newMeshOption.mesh_simplify) {
                setRawCheck(true)
                setSimplifyCheck(true)
            }
        }
        if (rodinMeshOption) {
            updateMeshOption(rodinMeshOption)
        } else if (logInfo?.preferences?.rodinGeoMeshOption && logInfo?.preferences?.rodinGeoMeshOption !== '') {
            const newMeshOption = JSON.parse(logInfo.preferences.rodinGeoMeshOption)
            updateMeshOption(newMeshOption)

        }
        return () => {
            if (openThreeBoxSelectortimerRef.current) {
                clearTimeout(openThreeBoxSelectortimerRef.current)
            }
            setControllerInfo({})
            if (queryIntervalRef.current) {
                clearInterval(queryIntervalRef.current);
            }
        }
    }, [])

    const setKeywords = async () => {
        const res = await getTaskSettings()
        const keywords = res?.data?.settings?.keyword
        if (keywords) {
            setPresetPrompts(keywords)
            presetPromptsRef.current = keywords
        } else {
            setPresetPrompts([
                'Symmetric Geometry',
                'Sharp Edges',
                'Smooth Edges',
                'Simple Geometry',
                'Complex Geometry',
                'Simple Geometry',
                'Game-ready',
                'Character',
            ])
            presetPromptsRef.current = [
                'Symmetric Geometry',
                'Sharp Edges',
                'Smooth Edges',
                'Simple Geometry',
                'Complex Geometry',
                'Simple Geometry',
                'Game-ready',
                'Character',
            ]
        }
    }


    const loadFromInit = async () => {
        const uuid = genPipeline.taskInfo.data;
        const resHistory = await rodinHistory({ uuid, step: taskDetail?.step === 'Created' || !taskDetail?.step ? 'ModelGenerate' : taskDetail.step });
        const versions = Object.keys(resHistory.data);
        const maxVersion = versions.reduce((max, version) => {
            const versionNumber = parseInt(version.substring(1));
            return versionNumber > max ? versionNumber : max;
        }, 0);
        const maxVersionKey = `v${maxVersion}`;
        const latestPreviewImage = await fetchObjectToLocalURL(resHistory.data[maxVersionKey]?.preview_image || taskDetail?.model_preview_info?.preview_sdf);

        const settings = resHistory.data[maxVersionKey]?.settings || false;
        setRedoCount(getCurrentUserTotalRedoCount(subscriptionsInfo, "GEO", isAllowedTo('billing.feature')))

        if (settings) {
            try {
                const settingsJson = await fetchSettings({ settings });
                const viewWeights = settingsJson.view_weights
                const prompt = settingsJson.prompt
                setPresetSymm([settingsJson?.sym_dict?.must_asym, settingsJson?.sym_dict?.must_sym])
                if (genPipeline?.geoLoaded?.status) {
                    initImageModeRef.current = settingsJson?.image_mode ? settingsJson.image_mode : false
                    extractAndSelectPrompts(prompt)
                }
                setViewWeights(viewWeights)
            } catch (error) {
                Sentry.captureException(error)
                console.error('Error fetching settings JSON:', error);
            }
        }

        // Push loading status to preview
        if (latestPreviewImage) {
            setGenPipeline(pre => {
                return {
                    ...pre,
                    taskInfo: {
                        ...pre.taskInfo,
                        status: false,
                    },
                    geoPreviewLoading: {
                        status: true,
                        data: latestPreviewImage,
                        timestamp: Date.now()
                    }
                }
            });
            setCurrentPreviewImage(latestPreviewImage)
        }
        startGuide()
    }

    const loadFromRestore = async () => {
        const restoreData = genPipeline.taskInfo.restore.data
        // If View Only
        if (restoreData.viewOnly) {
            setStage(STAGE_ENUM.DONE)
        }
        // Load Version
        setCurrentVersion(restoreData.geometry.version)
        // Load Weights
        setViewWeights(restoreData.geometry.viewWeights)
        // Load Prompt
        extractAndSelectPrompts(restoreData.geometry.geoPrompt)
        // Load Redo Count
        setRedoCount(getCurrentUserTotalRedoCount(subscriptionsInfo, "GEO", isAllowedTo('billing.feature')) - restoreData.geometry.versionCounter + 1)
        // Current Preview Image
        setCurrentPreviewImage(restoreData.geometry.sdfUrl)
        // Load Symmetry Status
        setPresetSymm([restoreData?.geometry?.symStatus?.must_asym, restoreData?.geometry?.symStatus?.must_sym])
        // Load Selected Direction
        setSelectedDirection(restoreData.geometry.direction)
        //bbox voxel pointcloud status
        setControllerInfo({
            voxel_condition: restoreData.geometry.voxel_condition,
            bbox_condition: restoreData.geometry.bbox_condition,
            pcd_condition: restoreData.geometry.pcd_condition,
            voxel_condition_cfg: restoreData.geometry?.voxel_condition_cfg,
            voxel_condition_weight: restoreData.geometry?.voxel_condition_weight,
            pcd_condition_uncertainty: restoreData.geometry?.pcd_condition_uncertainty,
            noModel: {
                bbox: restoreData.geometry?.bbox_condition,
                voxel: restoreData.geometry?.voxel_condition,
                pcd: restoreData.geometry?.pcd_condition
            }
        })

        if (threeController.current) {
            threeController.current.bboxCache.file = null
            threeController.current.pointsCache[threeController.current.newPointsIndex].file = null
            threeController.current.voxelsCache[threeController.current.newVoxelIndex].file = null
        }
    }

    useEffect(() => {
        if (controllerInfo.voxel_condition || controllerInfo.bbox_condition || controllerInfo.pcd_condition) {
            const preMeshParameters = JSON.parse(JSON.stringify(defaultMeshParameters))

            if (controllerInfo.bbox_condition) {
                //bbox
                const newPos = {
                    x: controllerInfo.bbox_condition[0],
                    y: controllerInfo.bbox_condition[1],
                    z: controllerInfo.bbox_condition[2]
                };
                preMeshParameters.bbox = {
                    ...preMeshParameters.bbox,
                    confirmed: true,
                    pos: newPos,
                    params: controllerInfo.bbox_condition,
                }
            } else if (controllerInfo.voxel_condition) {
                //voxel
                const { voxels, originalArray } = base64ToPos(controllerInfo.voxel_condition)
                preMeshParameters.voxel = {
                    ...preMeshParameters.voxel,
                    confirmed: true,
                    params: originalArray,
                    pos: voxels,
                    voxel_condition_cfg: controllerInfo.voxel_condition_cfg,
                    voxel_condition_weight: controllerInfo.voxel_condition_weight,
                }
                setVoxelScale(controllerInfo.voxel_condition_weight)
                setVoxelMode(controllerInfo.voxel_condition_cfg)
            } else {
                const posArr = []
                let len = controllerInfo.pcd_condition.length
                for (let i = 0; i < len; i++) {
                    const x = controllerInfo.pcd_condition[i][0]
                    const y = controllerInfo.pcd_condition[i][1]
                    const z = controllerInfo.pcd_condition[i][2]
                    posArr.push({
                        position: {
                            x: x,
                            y: y,
                            z: z
                        }
                    })
                }
                //point cloud
                preMeshParameters.pointCloud = {
                    ...preMeshParameters.pointCloud,
                    confirmed: true,
                    params: controllerInfo.pcd_condition,
                    pos: posArr,
                    pcd_condition_uncertainty: controllerInfo.pcd_condition_uncertainty,

                }
                setPcdUncertainty(controllerInfo.pcd_condition_uncertainty)
                const samplingIndex = SAMPLING_ARRAY.findIndex((item) => item == controllerInfo?.pcd_condition?.length)
                setSamplingVal(samplingIndex > -1 ? samplingIndex : 2)
            }
            if (boundingBoxRef.current) {
                const canvas = boundingBoxRef.current.querySelector('canvas')
                if (canvas) {
                    boundingBoxRef.current.removeChild(canvas);
                }
            }

            threeController.current = null
            setMeshParameters(preMeshParameters);
            // setNoModel(true)
        }
        setConditionReady(pre => {
            const updatePre = { ...pre }
            updatePre.self = true
            return updatePre
        })
    }, [controllerInfo])

    const restoreVoxel = () => {
        if (controllerInfo) {
            const preMeshParameters = JSON.parse(JSON.stringify(defaultMeshParameters))
            const { voxels, originalArray } = base64ToPos('AAAAAAAAAAAAAAAAAAAAAH4AfgB+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABw/n/+f/5/AAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHDAf8B/wH8AAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAGAAYABgAGAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAGAAYABgAGAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYABgAGAAYABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAGAAYABgAGAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAGAAYABgAGAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABgAGAAYABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwwH/Af8B/AAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHD+f/5//n8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH4AfgB+AAAAAAAAAAAAAAA=')
            preMeshParameters.voxel = {
                ...preMeshParameters.voxel,
                confirmed: true,
                params: originalArray,
                pos: voxels,
                voxel_condition_cfg: controllerInfo.voxel_condition_cfg,
                voxel_condition_weight: controllerInfo.voxel_condition_weight,
            }
            setVoxelScale(controllerInfo.voxel_condition_weight)
            setVoxelMode(controllerInfo.voxel_condition_cfg)
            if (boundingBoxRef.current) {
                const canvas = boundingBoxRef.current.querySelector('canvas')
                if (canvas) {
                    boundingBoxRef.current.removeChild(canvas);
                }
            }

            threeController.current = null
            setMeshParameters(preMeshParameters);
            // setNoModel(true)
        }
        setConditionReady(pre => {
            const updatePre = { ...pre }
            updatePre.self = true
            return updatePre
        })
    }

    useEffect(() => {
        if (genPipeline?.hold.status) return;

        if (stage === STAGE_ENUM.INIT) {
            initGeo()
        }

        if (genPipeline.geoConfirmed.status || genPipeline?.taskInfo?.restore?.data?.viewOnly) {
            setStage(STAGE_ENUM.DONE)
        } else {
            setStage(STAGE_ENUM.GENERATED)
        }

        async function initGeo() {
            setKeywords()
            if (genPipeline?.taskInfo?.status && !genPipeline?.taskInfo?.restore?.status) {
                await loadFromInit()
            } else if (genPipeline?.taskInfo?.restore?.status) {
                await loadFromRestore()
            }
            setConditionReady(pre => {
                const updatePre = { ...pre }
                updatePre.other = true
                return updatePre
            })
        }
    }, [genPipeline])

    const startGuide = () => {
        if (['ModelGenerate', 'Created'].includes(taskDetail?.step) && modalObj?.origin === 'generate') {
            // localStorage.removeItem('RedoGuide')
            if (!localStorage.getItem('RedoGuide')) {
                setTimeout(() => {
                    driverRedoGuide()
                    setRemaingShow(false)
                }, 2000);
            }
        }
    }

    const forceResetSDF = (sdf_image) => {
        const previewBoard = document.querySelector('.sdfPreview');
        const previewImage = document.querySelectorAll('.bottomSDFPreview');

        previewImage.forEach(previewBoard => {
            previewBoard.style.backgroundImage = `url("${sdf_image}")`;
        });

        if (previewBoard) {
            previewBoard.style.opacity = '0.6';
            setTimeout(() => {
                previewBoard.style.backgroundImage = `url("${sdf_image}")`;
                previewBoard.style.opacity = '1';
            }, 150);
        } else {
            console.error('Preview board element not found');
        }

    }

    const loadHistory = async (selectedHistory, previewMode = false) => {
        const settings = await fetchSettings({ settings: selectedHistory.settings });
        extractAndSelectPrompts(settings.prompt)
        setSelectedDirection(settings.image_label)
        setCurrentVersion(selectedHistory.version)
        setViewWeights(settings.view_weights)
        setCurrentPreviewImage(selectedHistory.sdf_image)
        setPresetSymm([settings?.sym_dict?.must_asym, settings?.sym_dict?.must_sym])
        setStage(STAGE_ENUM.GENERATED)
        setControllerInfo({
            voxel_condition: settings.voxel_condition,
            bbox_condition: settings.bbox_condition,
            pcd_condition: settings.pcd_condition,
            voxel_condition_cfg: settings?.voxel_condition_cfg,
            voxel_condition_weight: settings?.voxel_condition_weight,
            pcd_condition_uncertainty: settings?.pcd_condition_uncertainty,
            noModel: {
                bbox: settings?.bbox_condition,
                voxel: settings?.voxel_condition,
                pcd: settings?.pcd_condition
            }
        })
        if (previewMode) {
            forceResetSDF(selectedHistory.sdf_image)
        } else {
            setGenPipeline(pre => {
                return {
                    ...pre,
                    geoPreviewLoading: {
                        status: true,
                        data: selectedHistory.sdf_image,
                        timestamp: Date.now()
                    },
                }
            });
        }

    }


    useEffect(() => {
        if (genPipeline.geoConfirmed.status) return;
        // If history opened, save current stage for reference
        if (historyStatus.showHistoryList && !historyStatus.originalState) {
            setHistoryStatus({ ...historyStatus, originalState: { prompt: promptText, viewWeights: viewWeights, previewImage: currentPreviewImage, version: currentVersion } })
        }
        // If history closed without selecting, reset to original state
        if (!historyStatus.showHistoryList && historyStatus.originalState && historyStatus.selectedHistory === false) {
            forceResetSDF(historyStatus.originalState.previewImage)
            setViewWeights(historyStatus.originalState.viewWeights)
            setCurrentPreviewImage(historyStatus.originalState.previewImage)
            setHistoryStatus({ ...historyStatus, originalState: false })
            setCurrentVersion(historyStatus.originalState.version)
            currentViewingHistory.current = false
        }
        // If history selected, load history
        if (historyStatus.selectedHistory) {
            currentViewingHistory.current = historyStatus.selectedHistory
            loadHistory(historyStatus.selectedHistory, true).then(() => setHistoryStatus({ ...historyStatus, selectedHistory: false, historyList: [], originalState: false }))
        }
        // If preview history selected, load history for preview
        if (historyStatus.previewHistory && currentViewingHistory.current !== historyStatus.previewHistory) {
            currentViewingHistory.current = historyStatus.previewHistory
            loadHistory(historyStatus.previewHistory, true).then(() => setHistoryStatus({ ...historyStatus, previewHistory: false }))
        }
    }, [historyStatus]);

    useEffect(() => {
        if (taskDetail && isCreatorOrAbove()) {
            if (taskDetail.settings?.enable_advance_option) {
                setOptionChange(true)
            } else {
                setOptionChange(false)
            }
            const tempAdvOption = {
                'enable': {
                    status: taskDetail.settings?.enable_advance_option ? taskDetail.settings.enable_advance_option : false
                },
                'seed': {
                    value: taskDetail.settings?.seed ? taskDetail.settings.seed : -1
                },
                'rest': {
                    value: taskDetail.settings?.image_mode ? taskDetail.settings.image_mode === 'rest' ? taskDetail.settings.rest_bias : false : false
                },
                'sharp': {
                    value: taskDetail.settings?.sharp_bias ? taskDetail.settings.sharp_bias : 0
                },
                'cfg': {
                    value: taskDetail.settings?.guidance_scale ? taskDetail.settings.guidance_scale : 10
                },
                'step': {
                    value: taskDetail.settings?.inference_steps ? taskDetail.settings.inference_steps : 50
                },
                'negative_prompt': {
                    value: taskDetail.settings?.negative_prompt ? taskDetail.settings.negative_prompt : false
                }
            }
            setAdvOption(tempAdvOption)
        }
    }, [taskDetail, subscriptionsInfo])

    const extractAndSelectPrompts = async (rawPrompt = promptText, attempt = 0) => {
        if (presetPromptsRef.current.length === 0) {
            if (attempt >= 5) {
                console.error("Failed to load preset prompts after several attempts.");
                return;
            }
            await setKeywords();
            setTimeout(async () => {
                return await extractAndSelectPrompts(rawPrompt, attempt + 1);
            }, 1000);
            return;
        }
        const firstSentenceEndIndex = rawPrompt.indexOf('.');
        const firstSentence = rawPrompt.substring(0, firstSentenceEndIndex + 1);
        const restOfText = rawPrompt.substring(firstSentenceEndIndex + 1).trim();
        const newChosenList = [];
        const restOfTextLower = restOfText?.toLowerCase();
        let promptPartsLower = restOfTextLower.split(/[,.]+/).map(part => part.trim());
        let imageMode = false
        let initPrompt = false
        if (genPipeline.taskInfo?.restore?.data.geometry.imageMode) {
            imageMode = genPipeline.taskInfo?.restore?.data.geometry.imageMode
        } else {
            imageMode = initImageModeRef.current
        }

        promptPartsLower = [...new Set(promptPartsLower)];
        if ((taskDetail?.settings?.allow_face_enhance || imageMode) && (presetPrompts.length === 0 || presetPrompts.filter(item => item === 'T/A Pose').length === 0)) { //根据allow_face_enhance和首次settings内的image_mode参数判断改card是否支持t/a pose
            if (genPipeline.geoConfirmed?.status) {  //在材质生成阶段进行用户是否启用了t/a pose
                if (taskDetail?.settings?.image_mode === 'rest') {
                    const newPresetPrompts = presetPromptsRef.current.filter((old) => (old !== 'T/A Pose' && old !== 'Sharp'))
                    setPresetPrompts(['T/A Pose', 'Sharp', ...newPresetPrompts])
                    presetPromptsRef.current = ['T/A Pose', 'Sharp', ...presetPromptsRef.current]
                    setOptionModeRest(true)
                    promptPartsLower = ['t/a pose', ...promptPartsLower]
                } else {
                    const newPresetPrompts = presetPromptsRef.current.filter((old) => (old !== 'Sharp'))
                    setPresetPrompts(['Sharp', ...newPresetPrompts])
                    presetPromptsRef.current = ['Sharp', ...presetPromptsRef.current]
                }
                if (taskDetail?.settings?.sharp_bias === 2.5 && !taskDetail?.settings?.enable_advance_option) {
                    promptPartsLower = ['sharp', ...promptPartsLower]
                    setOptionSharp(true)
                }
            } else if (!genPipeline.geoConfirmed?.status) { //在几何生成阶段进行用户是否支持t/a pose
                setOptionModeClose(true)
                const newPresetPrompts = presetPromptsRef.current.filter((old) => (old !== 'T/A Pose' && old !== 'Sharp'))
                setPresetPrompts(['T/A Pose', 'Sharp', ...newPresetPrompts])
                presetPromptsRef.current = ['T/A Pose', 'Sharp', ...presetPromptsRef.current]
                if (taskDetail?.settings?.sharp_bias === 2.5 && !taskDetail?.settings?.enable_advance_option) {
                    promptPartsLower = ['sharp', ...promptPartsLower]
                    setOptionSharp(true)
                }
                if (taskDetail?.settings?.image_mode === 'rest') {
                    promptPartsLower = ['t/a pose', ...promptPartsLower]
                    setOptionModeRest(true)
                }
            }
            initPrompt = true
        } else if ((!taskDetail?.settings?.allow_face_enhance && !imageMode) && (presetPrompts.length === 0 || presetPrompts.filter(item => item === 'Sharp').length === 0)) {
            const newPresetPrompts = presetPromptsRef.current.filter((old) => old !== 'Sharp')
            setPresetPrompts(['Sharp', ...newPresetPrompts])
            if (taskDetail?.settings?.sharp_bias === 2.5 && !taskDetail?.settings?.enable_advance_option) {
                promptPartsLower = ['sharp', ...promptPartsLower]
                setOptionSharp(true)
            }
            presetPromptsRef.current = ['Sharp', ...presetPromptsRef.current]
            initPrompt = true
        }

        if (!initPrompt) {
            if (optionModeRest) { //选中t/a pose按钮时点击confirm时保存t/a pose选中状态
                if (optionSharp) {
                    const newPromptPartsLower = promptPartsLower.filter((old) => old !== 'sharp')
                    promptPartsLower = ['sharp', ...newPromptPartsLower]
                }
                const newPromptPartsLower = promptPartsLower.filter((old) => old !== 't/a pose')
                promptPartsLower = ['t/a pose', ...newPromptPartsLower]
            } else {
                if (optionSharp) {
                    const newPromptPartsLower = promptPartsLower.filter((old) => old !== 'sharp')
                    promptPartsLower = ['sharp', ...newPromptPartsLower]
                }
            }
        }
        presetPromptsRef.current.forEach((presetPrompt, index) => {
            const prematchIndex = promptPartsLower.findIndex(part => part === presetPrompt?.toLowerCase());
            if (prematchIndex !== -1) {
                newChosenList.push(index);
                promptPartsLower.splice(prematchIndex, 1)
            }
        });
        let ChosenList = newChosenList
        if (preChosenList.length > 0 && stage === STAGE_ENUM.SYMMETRICAL) { //在未选择redo时点击confirm的时候返回原先的值
            ChosenList = preChosenList
        }
        if (preChosenList.length === 0 && (taskDetail?.settings?.image_mode === 'rest' || (taskDetail?.settings?.sharp_bias === 2.5 && !taskDetail?.settings?.enable_advance_option))) { //在初次进入card时保存当前值
            setPreChosenList(ChosenList)
        }
        setChosenList(ChosenList);
        const unmatchedPrompts = promptPartsLower.join(', ');
        const processedPrompt = firstSentence + ' ' + unmatchedPrompts
        setPromptText(processedPrompt);
        return processedPrompt;
    };

    useEffect(() => {
        presetPromptsRef.current = presetPrompts;
    }, [presetPrompts]);

    const settingChanged = () => {
        setStage(STAGE_ENUM.CHANGED);
    }

    const handlePromptTextChange = (e) => {
        settingChanged()
        setPromptText(e.target.value);
    };

    const handleWeightChange = (newWeights) => {
        settingChanged()
        setWeights(newWeights);
    };


    const handlerChoosePrompt = (index, item) => {
        settingChanged()
        const list = [...chosenList];
        if (list.includes(index)) {
            list.splice(list.indexOf(index), 1);
            if (item === 'T/A Pose') {
                setOptionModeRest(false)
            }
            if (item === 'Sharp') {
                setOptionSharp(false)
            }
        } else {
            list.push(index);
            if (item === 'T/A Pose') {
                setOptionModeRest(true)
            }
            if (item === 'Sharp') {
                setOptionSharp(true)
            }
        }
        setChosenList(list);
    };

    const handlerChoosePolygons = (e, index) => {
        e.stopPropagation()
        if (!subscriptionsInfo.plan_level && index !== 2 && index !== -2) {
            setShowSubLinkTip(index)
            return
        }
        if (index === -2) {
            setRawCheck(true)
            setPrePolygonsIndex(currentPolygonsIndex)
        }
        setShowSubLinkTip(false)
        setCurrentPolygonsIndex(index)
    }

    const calculateResultFromPointerArr = () => {
        const sum = pointerArr
            .slice(1)
            .reduce((acc, value, index) => acc + (value - pointerArr[index]), 0);
        let tempSum = 0;
        const resultArr = pointerArr.slice(1).map((value, index) => {
            const itemNum = Number(((value - pointerArr[index]) / sum).toFixed(2));
            if (index === pointerArr.length - 2) {
                return addAndSubtract(1, tempSum, '-');
            }
            tempSum = addAndSubtract(itemNum, tempSum, '+');
            return itemNum;
        });
        return resultArr;
    };

    const combinePrompt = () => {
        const selectedPresets = chosenList.map(index => presetPrompts[index]);
        const filterSelectedPresets = selectedPresets.filter(item => (item !== 'T/A Pose' && item !== 'Sharp'))
        const trimmedPromptText = promptText.trim();
        const combinedText = trimmedPromptText.endsWith('.') ? trimmedPromptText + ' ' : trimmedPromptText + '. ';
        return combinedText + filterSelectedPresets.join(', ')
    }


    const handleRedo = async () => {
        try {
            if (taskTimeRef.current) {
                clearInterval(taskTimeRef.current)
            }
            taskTimeValueRef.current = 0
            const defalutTime = new Date(globalTimeStamp).getTime()
            const cardTime = new Date(taskDetail.time).getTime()
            if (defalutTime - cardTime > 0) {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_PRE_MODEL'),
                });
                return;
            }
            if (redoCount <= 0) {
                tip({
                    type: 'primary',
                    content: t('TIP_PRIMARY_RODINMAT_MAX_REDO'),
                });
                return
            } else if (!promptText) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_PROMPT_EMPTY'),
                });
                return
            }

            setStage(STAGE_ENUM.GENERATING);
            setPreChosenList(chosenList)

            const newPrompt = combinePrompt()
            const view_weights = calculateResultFromPointerArr()
            const redoParams = {
                prompt: newPrompt,
                uuid,
                view_weights: view_weights,
                image_label: selectedDirection?.slice(0, view_weights.length),
                condition_mode: taskDetail?.settings?.condition_mode || 'fuse'
            }
            if (meshParameters['bbox'].confirmed) {
                redoParams.bbox_condition = meshParameters['bbox'].params
            }

            if (meshParameters['voxel'].confirmed) {
                const voxel_condition = pos2Base64(meshParameters['voxel'].params)
                redoParams.voxel_condition = voxel_condition
                redoParams.voxel_condition_cfg = meshParameters['voxel'].voxel_condition_cfg
                redoParams.voxel_condition_weight = +meshParameters['voxel'].voxel_condition_weight
            }

            if (meshParameters['pointCloud'].confirmed) {
                redoParams.pcd_condition = meshParameters['pointCloud'].params
                redoParams.pcd_condition_uncertainty = +meshParameters['pointCloud'].pcd_condition_uncertainty

            }

            if (advOption['enable'].status) {
                redoParams.enable_advance_option = true
                if (advOption['rest'].value !== false && advOption['rest'].value >= 0) {
                    redoParams.rest_bias = advOption['rest'].value
                    redoParams.image_mode = 'rest'
                } else {
                    redoParams.image_mode = 'recon'
                }

                if (advOption['cfg'].value) {
                    redoParams.guidance_scale = advOption['cfg'].value
                }

                if (advOption['step'].value) {
                    redoParams.inference_steps = advOption['step'].value
                }

                if (advOption['sharp'].value !== false && advOption['sharp'].value >= -5) {
                    if (optionSharp) {
                        redoParams.sharp_bias = 2.5
                    } else {
                        redoParams.sharp_bias = advOption['sharp'].value
                    }
                }

                if (advOption['negative_prompt'].value) {
                    redoParams.negative_prompt = advOption['negative_prompt'].value
                }
                if (advOption['seed'].value !== -1) {
                    redoParams.geoseed = Number(advOption['seed'].value)
                }
            } else {
                redoParams.enable_advance_option = false
                if (optionModeRest) {
                    redoParams.image_mode = 'rest'
                } else {
                    redoParams.image_mode = 'recon'
                }
                if (optionSharp) {
                    redoParams.sharp_bias = 2.5
                } else {
                    redoParams.sharp_bias = 0
                }

            }

            const res = await rodinUpdate(redoParams)
            const subKey = res?.data?.job?.subscription_key
            const jobid = res?.data?.job?.uuids[0]
            if (res?.data?.error || !subKey) {
                setStage(STAGE_ENUM.GENERATED)
                if (res?.data?.error === 'INSUFFICIENT_BALANCE') {
                    driverGuide()
                } else {
                    tip({
                        type: 'error',
                        presetText: 'ERROR',
                        content: t('TIP_ERR_GEN_FAILED'),
                    });
                }
                return
            }
            setKeepRodinBoard(true)
            setReconnectAttempts(0)

            let queued = 0
            let hasStartedQueued = false
            let hasStartedGenerating = false

            connect(subKey, jobid)
            // 创建一个启动查询的函数
            const startQueryInterval = () => {
                if (queryIntervalRef.current) {
                    clearInterval(queryIntervalRef.current);
                }
                queryIntervalRef.current = setInterval(() => {
                    query(jobid);
                }, 10000);
            };
            trackEvent('Rodin - Geometry - Redo: Start', redoParams, genPipeline?.taskInfo.data)
            taskTimeRef.current = setInterval(()=>{
                taskTimeValueRef.current = taskTimeValueRef.current + 1
            },1000)
            // 初始启动查询
            startQueryInterval();
            onMessage('message', async (data, res) => {
                if (res?.jobStatus === 'Queued') {
                    setIsQueued(true)
                    if (!hasStartedQueued) {
                        setGeneratePercentage(0)
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, 10)
                        queued = res?.jobWaitingLength ? res.jobWaitingLength:0 + 1
                        hasStartedQueued = true
                    } else {
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, -((res?.jobWaitingLength ? res.jobWaitingLength:0) * 10 - Number(queued) * 10))
                    }

                }
                if (res?.jobStatus === 'BackPressure') {
                    setGeneratePercentage(0)
                    setIsQueued(true)
                }
                if (res?.jobStatus === 'Running' && !hasStartedGenerating) {

                    // 10秒后重新启动查询
                    setTimeout(() => {
                        startQueryInterval();
                    }, 10000);
                    if (queued === 0) {
                        setGeneratePercentage(0)
                    } else {
                        doneFakeProgressBar(setGeneratePercentage, queued * 10)
                    }
                    setIsQueued(false)
                    hasStartedGenerating = true
                    const progressBarDelay = 20 + queued;
                    startFakeProgressBar(setGeneratePercentage, progressBarDelay)
                }
                if (res?.jobStatus === 'Canceled') {
                    trackEvent('Rodin - Geometry - Redo: Canceled', false, genPipeline?.taskInfo.data)
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'failed_geometry_redo',
                            label: 'pressure_tracking'
                        }
                    )
                    if (queryIntervalRef.current) {
                        clearInterval(queryIntervalRef.current);
                    }
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                    setIsQueued(false)
                    setStage(STAGE_ENUM.GENERATED)
                    tip({
                        type: 'error',
                        content: t('TIP_ERR_KINDLY_ANEW')
                    })
                    disconnect()
                    return
                }
                if (res?.jobStatus === 'Succeeded') {
                    if (queryIntervalRef.current) {
                        clearInterval(queryIntervalRef.current);
                    }
                    if (!hasStartedGenerating) {
                        if (queued === 0) {
                            setGeneratePercentage(0)
                        } else {
                            doneFakeProgressBar(setGeneratePercentage, queued * 10)
                        }
                    }
                    setIsQueued(false)
                    trackEvent('Rodin - Geometry - Redo: Succeeded', { credits:0, executionTime:taskTimeValueRef.current }, genPipeline?.taskInfo.data)
                    doneFakeProgressBar(setGeneratePercentage, 100)
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    setTimeout(async () => {
                        setStage(STAGE_ENUM.GENERATED);
                        setGeneratePercentage(0)
                        taskTimeValueRef.current = 0
                        setRedoCount(redoCount - 1);
                        const res_history = await rodinHistory({ uuid });
                        setKeepRodinBoard(false)
                        const versions = Object.keys(res_history.data);
                        const maxVersion = versions.reduce((max, version) => {
                            const versionNumber = parseInt(version.substring(1));
                            return versionNumber > max ? versionNumber : max;
                        }, 0);
                        const maxVersionKey = `v${maxVersion}`;
                        setRodinModalLoading(true)
                        await new Promise((resolve) => setTimeout(resolve, 1000))
                        setRodinModalLoading(false)
                        const latestPreviewImage = res_history.data[maxVersionKey]?.preview_image || false;
                        setCurrentPreviewImage(latestPreviewImage)
                        setCurrentVersion('latest')
                        setHistoryStatus({ ...historyStatus, selectedHistory: false })
                        if (latestPreviewImage) {
                            setGenPipeline(pre => {
                                return {
                                    ...pre,
                                    geoPreviewLoading: {
                                        status: true,
                                        data: latestPreviewImage,
                                        timestamp: Date.now()
                                    }
                                }
                            });
                        }
                        disconnect()
                    }, 1000);
                }
            }, () => {
                ReactGA.event(
                    {
                        category: 'hyper3d',
                        action: 'failed_geometry_redo',
                        label: 'pressure_tracking'
                    }
                )
                if (queryIntervalRef.current) {
                    clearInterval(queryIntervalRef.current);
                }
                if (taskTimeRef.current) {
                    clearInterval(taskTimeRef.current)
                }
                taskTimeValueRef.current = 0
                setIsQueued(false)
                setStage(STAGE_ENUM.GENERATED)
                tip({
                    type: 'error',
                    content: t('TIP_ERR_KINDLY_ANEW')
                })
                disconnect()
                return
            });
        } catch (error) {
            trackEvent('Rodin - Geometry - Redo: Failed', false, genPipeline?.taskInfo.data)
            console.log('api-error', error);
            setStage(STAGE_ENUM.GENERATED);
        }

    };

    useEffect(() => {
        if (stage === STAGE_ENUM.GENERATED) {
            setGeneratePercentage(0)
        }
    }, [stage])

    const driverGuide = (balance) => {
        setModalObj({ ...modalObj, state: false });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setOpenPaymentInfo({
            ...openPaymentInfo,
            state: true,
            group: taskDetail?.group,
            balance: balance,
            step: 1
        })

        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
        });
        const target = taskDetail?.group ? "#rechargeGroup #rechargePopup" : "#rechargeSelf #rechargePopup"
        driverObj.highlight({
            element: target,
            popover: {
                title: t('DRIVEROBJ_BALANCE_TITLE'),
                description: t('DRIVEROBJ_BALANCE_DESC'),
                popoverClass: "rechargedriver"
            }
        });
        if (document.querySelector(target)) {
            document.querySelector(target).addEventListener("click", () => {
                driverObj.destroy();
            });
        }
    }

    const driverRedoGuide = () => {
        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
            showButtons: ["next"],
            allowClose: false,
            showProgress: true,
            onDestroyStarted: () => {
                setRemaingShow(true)
                driverObj.destroy();
                localStorage.setItem('RedoGuide', true)
            },
            steps: [
                {
                    element: "#RedoTab",
                    popover: {
                        description: t('DRIVEROBJ_SWITCH_RODOTAB_DESC'),
                        popoverClass: "RedoDriver"
                    }
                },
                {
                    element: "#rodinWeightBox",
                    popover: {
                        description: t('DRIVEROBJ_SWITCH_WEIGHT_BOX_DESC'),
                        popoverClass: "RedoDriver"
                    }
                }
            ]
        });

        driverObj.drive();
    }

    const handleOpenEdit = () => {
        sessionStorage.setItem('task_uuid', taskDetail.task_uuid)
        sessionStorage.setItem('symmetric', taskDetail.settings.symmetric)
        const sculptGlInfo = {
            origin: window.location.origin + "/" + taskDetail.task_uuid,
            modelUrl: taskDetail.model_preview_info.model_obj,
            type: 'card',
            activeIndex: activeIndex,
            symmetric: taskDetail.settings.symmetric,
            task_uuid: taskDetail.task_uuid,
            status: "editor",
        }
        sessionStorage.setItem('SculptGLInfo', JSON.stringify(sculptGlInfo))
        window.location.href = `${window.location.origin}/proxy/rodin/MeshEditor/?env=netease`;
        // const encodedUrl = taskDetail.model_preview_info.model
        // const decodedUrl = decodeURIComponent(encodedUrl);
        // console.log(decodedUrl);

    }

    const handleError = (message, type = 'error') => {
        tip({
            type,
            presetText: 'ERROR',
            content: message,
        });
        // setStage(STAGE_ENUM.GENERATED);
        // disconnect();
    }

    const handleConfirm = async (symmetricStatus) => {
        try {
            if (isAllowedTo('billing.feature')) {
                const isGroupLowBalance = taskDetail?.group && (balance.groupBalance / 10) < 0.5
                const isPersonalLowBalance = !taskDetail?.group && (balance.selfBalance / 10 + subscriptionsInfo.wallet_balance / 10) < 0.5
                if (isGroupLowBalance || isPersonalLowBalance) {
                    driverGuide()
                    return
                }
            }
            if (taskTimeRef.current) {
                clearInterval(taskTimeRef.current)
            }
            taskTimeValueRef.current = 0

            setStage(STAGE_ENUM.GENERATING);

            const uuid = genPipeline.taskInfo.data;
            const qualityMap = ['extra-low', "low", "medium", "high"]

            // Consistency recovery
            const resHistory = await rodinHistory({ uuid });
            const length = Object.keys(resHistory.data).length;
            const targetVersion = (currentVersion === 'latest') ? `v${length}` : currentVersion;
            const settingsUrl = resHistory.data[targetVersion].settings
            const settingsJson = await fetchSettings({ settings: settingsUrl })
            const processedPrompt = await extractAndSelectPrompts(settingsJson.prompt)

            if (!settingsUrl || !settingsJson || !processedPrompt) {
                handleError('Fail to fetch settings')
                setStage(STAGE_ENUM.GENERATED)
                return false
            }
            setViewWeights(settingsJson.view_weights)
            const rodinGeoMeshOption = {
                mesh_export_type: currentPolygonsIndex === -2 ? 'Raw' : 'Quad',
                quality: currentPolygonsIndex === -2 ? qualityMap[prePolygonsIndex] : qualityMap[currentPolygonsIndex],
                mesh_smooth: smoothCheck,
                mesh_simplify: simplifyCheck
            }
            updatePreference({
                preference: {
                    rodinGeoMeshOption: JSON.stringify(rodinGeoMeshOption),
                },
            });
            setRodinMeshOption(rodinGeoMeshOption)

            const confirmParams = {
                uuid: uuid,
                quality: currentPolygonsIndex === -2 ? 'medium' : qualityMap[currentPolygonsIndex],
                symmetric: symmetricStatus,
                version: targetVersion,
                use_hyper: true,
                mesh_export_type: currentPolygonsIndex === -2 ? 'Raw' : 'Quad',
                mesh_smooth: currentPolygonsIndex !== -2 && smoothCheck,
                mesh_simplify: currentPolygonsIndex === -2 && simplifyCheck
            }
            const res = await rodinConfirm(confirmParams);
            const subKey = res?.data?.job?.subscription_key
            const jobid = res?.data?.job?.uuids[0]
            if (res?.data?.error || !subKey) {
                setStage(STAGE_ENUM.GENERATED)
                if (res?.data?.error === 'INSUFFICIENT_BALANCE') {
                    driverGuide()
                } else {
                    tip({
                        type: 'error',
                        presetText: 'ERROR',
                        content: t('TIP_ERR_GEN_FAILED'),
                    });
                }
                setStage(STAGE_ENUM.GENERATED);
                return false
            }
            setKeepRodinBoard(true)
            setReconnectAttempts(0)
            let queued = 0
            let hasStartedQueued = false
            let hasStartedGenerating = false
            connect(subKey, jobid)
            // 创建一个启动查询的函数
            const startQueryInterval = () => {
                if (queryIntervalRef.current) {
                    clearInterval(queryIntervalRef.current);
                }
                queryIntervalRef.current = setInterval(() => {
                    query(jobid);
                }, 10000);
            };
            trackEvent('Rodin - Geometry - Confirm: Start', confirmParams, genPipeline?.taskInfo.data)
            taskTimeRef.current = setInterval(()=>{
                taskTimeValueRef.current = taskTimeValueRef.current + 1
            },1000)
            // 初始启动查询
            startQueryInterval();
            onMessage('message', async (data, res) => {
                if (res?.jobStatus === 'Queued') {
                    setIsQueued(true)
                    if (!hasStartedQueued) {
                        setGeneratePercentage(0)
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, 10)
                        queued = res?.jobWaitingLength ? res.jobWaitingLength:0 + 1
                        hasStartedQueued = true
                    } else {
                        const progressBarDelay = 50;
                        startFakeProgressBar(setGeneratePercentage, progressBarDelay, -((res?.jobWaitingLength ? res.jobWaitingLength:0) * 10 - Number(queued) * 10))
                    }

                }
                if (res?.jobStatus === 'BackPressure') {
                    setGeneratePercentage(0)
                    setIsQueued(true)
                }
                if (res?.jobStatus === 'Running' && !hasStartedGenerating) {
                    // if (queryIntervalRef.current) {
                    //     clearInterval(queryIntervalRef.current)
                    // }
                    if (queued === 0) {
                        setGeneratePercentage(0)
                    } else {
                        doneFakeProgressBar(setGeneratePercentage, queued * 10)
                    }
                    setIsQueued(false)
                    hasStartedGenerating = true
                    const progressBarDelay = 20 + queued;
                    startFakeProgressBar(setGeneratePercentage, progressBarDelay)
                }
                // If confirm failed
                if (res?.jobStatus === 'Canceled') {
                    trackEvent('Rodin - Geometry - Confirm: Canceled', false, genPipeline?.taskInfo.data)
                    ReactGA.event(
                        {
                            category: 'hyper3d',
                            action: 'canceled_geometry_confirm',
                            label: 'pressure_tracking'
                        }
                    )
                    if (queryIntervalRef.current) {
                        clearInterval(queryIntervalRef.current)
                    }
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    taskTimeValueRef.current = 0
                    tip({
                        type: 'warning',
                        content: t('TIP_WRAN_RODINGEO_REDOING')
                    })
                    disconnect()
                    await handleRedo()
                    return
                }
                // Fetch preview images
                if (res?.jobStatus === 'Succeeded') {
                    if (queryIntervalRef.current) {
                        clearInterval(queryIntervalRef.current)
                    }
                    if (!hasStartedGenerating) {
                        if (queued === 0) {
                            setGeneratePercentage(0)
                        } else {
                            doneFakeProgressBar(setGeneratePercentage, queued * 10)
                        }
                    }
                    trackEvent('Rodin - Geometry - Confirm: Succeeded', { credits:0.5, executionTime:taskTimeValueRef.current }, genPipeline?.taskInfo.data)
                    setIsQueued(false)
                    if (taskTimeRef.current) {
                        clearInterval(taskTimeRef.current)
                    }
                    doneFakeProgressBar(setGeneratePercentage, 100)
                    setTimeout(async () => {
                        setKeepRodinBoard(false)
                        setStage(STAGE_ENUM.DONE)
                        taskTimeValueRef.current = 0
                        setGeneratePercentage(0)
                        const card_res = await getTaskDetail(uuid);
                        const modelUrl = card_res.data.model_preview_info.model
                        const images = card_res.data.rodin_generate_info.mesh_input_images
                        if (card_res?.step !== 'ModelRefine') {
                            card_res.step = 'ModelRefine'
                        }
                        setTaskDetail(card_res.data)
                        const newDefaultImageURLs = Object.keys(images).map(key => {
                            return {
                                fileName: key.split('/').pop(),
                                data: images[key],
                                file: {}
                            };
                        });
                        refreshInfo(taskDetail?.group ? 'group' : 'user')
                        setDefaultImageURLs(newDefaultImageURLs);

                        // Update pipeline
                        setRodinModalLoading(true)

                        setGenPipeline(pre => {
                            return {
                                ...pre,
                                geoPreviewLoading: {
                                    status: true,
                                    data: currentPreviewImage,
                                    timestamp: Date.now()
                                },
                                geoLoading: {
                                    status: true,
                                    data: modelUrl,
                                    timestamp: Date.now()
                                },
                                geoConfirmed: {
                                    status: true,
                                    data: processedPrompt,
                                }
                            }
                        });
                        disconnect()
                    }, 1000);
                }
            }, () => {
                ReactGA.event(
                    {
                        category: 'hyper3d',
                        action: 'failed_geometry_confirm',
                        label: 'pressure_tracking'
                    }
                )
                if (queryIntervalRef.current) {
                    clearInterval(queryIntervalRef.current)
                }
                if (taskTimeRef.current) {
                    clearInterval(taskTimeRef.current)
                }
                taskTimeValueRef.current = 0
                setStage(STAGE_ENUM.GENERATED)
                tip({
                    type: 'error',
                    content: t('TIP_ERR_KINDLY_ANEW')
                })
                disconnect()
                return false
            });
        } catch (error) {
            trackEvent('Rodin - Geometry - Confirm: Failed', false, genPipeline?.taskInfo.data)
            setStage(STAGE_ENUM.GENERATED)
        }
    }

    const handleConfirmOrGenerate = async (enforceConfirm, symmetricStatus) => {
        const defalutTime = new Date(globalTimeStamp).getTime()
        const cardTime = new Date(taskDetail.time).getTime()
        if (defalutTime - cardTime > 0) {
            tip({
                type: 'error',
                content: t('TIP_ERR_PRE_MODEL'),
            });
            return;
        }
        if(!localStorage.getItem('proCheck') && currentPolygonsIndex !== -2){
            setOpenProCheck(true)
            return;
        }
        if (enforceConfirm) {
            await handleConfirm(symmetricStatus)
            return
        }
        try {
            switch (stage) {
                case STAGE_ENUM.GENERATE:
                    await startFakeProgressBar(setGeneratePercentage)
                    setStage(STAGE_ENUM.GENERATED)
                    break;
                case STAGE_ENUM.GENERATED:
                    // await handleConfirm()
                    if (asymmetryCheck) {
                        // When the forced asymmetry option is selected
                        await handleConfirmOrGenerate(true, false);
                        return;
                    }
                    if (!presetSymm[0] && !presetSymm[1]) {
                        if (currentPolygonsIndex === -2) {
                            await handleConfirmOrGenerate(true, false)
                            return;
                        }
                        setStage(STAGE_ENUM.SYMMETRICAL)
                    } else if (presetSymm[0]) {
                        await handleConfirmOrGenerate(true, false)
                    } else if (presetSymm[1]) {
                        await handleConfirmOrGenerate(true, true)
                    }
                    break;
                case STAGE_ENUM.CHANGED:
                    setStage(STAGE_ENUM.CHANGED_CONFIRM)
                    break;
                default:
                    break;
            }
        } catch (error) {
            Sentry.captureException(error);
            console.error(error);
        }
    }

    const handlerOpenSub = () => {
        setModalObj((pre) => {
            return {
                ...pre,
                state: false
            }
        })
        setShowSubscribe(true);
    }

    const handlerSetCheck = (boolean) => {
        setCheck(boolean)
    }

    const handleShowCredits = () => {
        if (isAllowedTo('billing.view')) {
            setComfirmBtnInfo(<span><span className="line-through">1 Credit</span> <span>0.5 Credits</span></span>)
        }
    }

    const handleCloseCredits = () => {
        setComfirmBtnInfo(t('BUTTON_SMALL_GEO_CONFIRM'))
    }

    const handleCheckBox = (e) => {
        e.stopPropagation()
        if (!isCreatorOrAbove()) {
            setShowSubLinkTip(true)
            return
        }
        setCheckHyper(pre => !pre)
    }


    const parseSelectedDirection = (index, imageSelectedDirection) => {
        setStage(STAGE_ENUM.CHANGED)

        setSelectedDirection(selectedDirection.map((item, i) => {
            if (i === index) {
                return conditionMapping[imageSelectedDirection]
            }
            return item
        }))
    }

    const cancelConfirmed = (index, e) => {
        if (meshValues[index].confirmed) {
            threeController.current && threeController.current.cancelConfirmed(meshKeys[index])
            e.stopPropagation()
            setMeshParameters(prev => {
                return meshKeys.reduce((acc, key, i) => {
                    const updatedState = {
                        ...acc,
                        [key]: {
                            ...prev[key],
                            confirmed: i === index ? false : prev[key].confirmed,
                        }
                    };
                    return updatedState;
                }, {});
            });

            return
        }
    }

    useEffect(() => {
        if (presetPrompts.length > 0 && swiperRef.current?.swiper) {
            // 强制更新 Swiper
            swiperRef.current.swiper.update();
        }
    }, [presetPrompts]);

    const handleCheckConfirmedStatus = (modelFile, index, eTarget) => {
        // e.stopPropagation()
        // if (index >= 1 && !isCreator) {
        //     const gotoSubscribe = () => {
        //         closeModal()
        //         setShowSubscribe(true)
        //     }

        //     openModal(<div className='w-full flex flex-col items-center select-none'>
        //         <div className='text-[rgba(45,45,45,1)] font-bold text-[20px] text-center w-full'>{t('THREEWRAPPER_SUBSCRIPTION_REQUIRED')}</div>
        //         <p className='text-[14px] text-[rgba(102,102,102,1)]'>{t('THREEWRAPPER_SUB_TIP')}</p>
        //         <div className='flex text-[14px] my-[12px] gap-[12px]'>
        //             <button onClick={() => closeModal()} className='w-[159px] h-[44px] flex-center border-none cursor-pointer transition-300-ease bg-[rgba(176,176,176,0.5)] text-[rgba(48,48,48,1)] hover:bg-[rgba(176,176,176,0.3)] hover:text-[rgba(26,26,26,1)] rounded-[22px]'>{t('THREEWRAPPER_CANCEL')}</button>
        //             <button onClick={gotoSubscribe} className='w-[159px] h-[44px] flex-center border-none cursor-pointer [background:linear-gradient(180deg,_#6D49FF_0%,_#A347FF_100%)] hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)] text-[#fff] rounded-[22px]'>{t('THREEWRAPPER_SUB_NOW')}</button>
        //         </div>
        //     </div>)
        //     return
        // }

        setActiveIndex(index)
        if (!eTarget.current) {
            tip({
                type: 'error',
                content: t('TIP_ERR_NO_CAVANS')
            })
            return
        }

        if (!meshValues[index].confirmed && !meshValues[index].pos.length) {
            //打开一个hraft窗口
            handleOpenUploadBox(index, eTarget)
            // fileInputRef.current.click()
            return
        }
        handleOpenBoundingBox(modelFile, index, eTarget, false)
    }

    const handleOpenUploadBox = (index, eTarget) => {

        const { left, top } = eTarget.current.getBoundingClientRect()
        if (left && top) {
            setOpenThreeWrapper({
                status: true,
                left: left,
                top: top,
                upload: true
            })
            setTimeout(() => {
                setOpenRange(true)
            }, 300);
            setActiveIndex(index)
        }
    }

    useEffect(() => {
        if (threeController?.current?.currentObeject?.file) {
            setNoModel(false)
        } else {
            setNoModel(true)
        }
    }, [threeController?.current?.currentObeject])

    const handleOpenBoundingBox = (modelFile, index, eTarget) => {
        let { left, top } = eTarget.current.getBoundingClientRect()
        if (left && top) {
            // if (modelFile) {
            //     setNoModel(false)
            // } else {
            //     let nomodelTag = (index === 0 && controllerInfo?.noModel?.bbox) ||
            //         (index === 1 && controllerInfo?.noModel?.voxel) ||
            //         (index === 2 && controllerInfo?.noModel?.pcd)
            //     setNoModel(nomodelTag)
            // }
            if ((window.innerHeight < 700 || window.innerWidth < 1280) && index === 2) {
                left = left - 100
            }
            setOpenThreeWrapper({
                status: true,
                left: left,
                top: top,
                upload: false
            })
            setTimeout(() => {
                setOpenRange(true)
            }, 300);
            setActiveIndex(index)
            setLoading(true)
            setTimeout(async () => {
                if (!threeController.current) {
                    const options = {
                        name: "editorcondition",
                        renderTarget: boundingBoxRef.current,
                        meshParameters,
                        modelType: meshKeys[index],
                        initmodel: modelFile,
                        loadingcb: (close) => {
                            setLoading(false)
                            if (close) {
                                setOpenThreeWrapper(pre => ({
                                    ...pre,
                                    status: false
                                }))
                                setOpenRange(false)
                                threeController.current.canResize = false
                            }
                        },
                        pcdUncertainty: meshValues[2].pcd_condition_uncertainty,
                        sampling: SAMPLING_ARRAY[samplingVal],
                        textureCache: textureCache,
                        tip: tip,
                        translation: t,
                        openModal: openWatertightModal,
                        setMeshParameters: setMeshParameters,
                        handleQuitOrthCamera: handleQuitOrthCamera,
                    }
                    threeController.current = new ThreeController(options)
                    await threeController.current.editorpageInit()
                    // threeController.current.editorpageUpdateMesh(meshKeys[index], modelFile)
                } else {
                    threeController.current.canResize = true
                    threeController.current.editorpageUpdateMesh(meshKeys[index], modelFile)
                }
                threeController.current.registerUpdateSliderValueFunction(updateSliderValue);
            }, 500);
        }
    }

    const updateSliderValue = (newValue) => {
        setSliderValue(newValue);
    };

    const openWatertightModal = () => {
        function confirm() {
            closeModal()
        }

        function cancel() {
            closeModal()
            handleClearModel()
        }

        function useVoxel() {
            closeModal()
            setActiveIndex(1)
            threeController.current && threeController.current.useVoxel()
        }


        openModal(<div className='w-full flex flex-col items-center select-none'>
            <div className='text-[rgba(45,45,45,1)] font-bold text-[20px] text-center w-full'>{t('THREEWRAPPER_WATER_MESH_REQUIRED')}</div>
            <p className='text-[14px] text-[rgba(102,102,102,1)]'>{t('THREEWRAPPER_WATER_MESH_TIP_1')}<span className='text-[rgba(45,45,45,1)] font-bold'>{t('THREEWRAPPER_WATER_MESH_TIP_2')}</span>{t('THREEWRAPPER_WATER_MESH_TIP_3')}<span className='text-[rgba(45,45,45,1)] font-bold'>{t('THREEWRAPPER_WATER_MESH_TIP_4')}</span>{t('THREEWRAPPER_WATER_MESH_TIP_5')}</p>
            <div className='flex text-[14px] my-[12px] gap-[12px]'>
                <button onClick={cancel} className='w-[159px] h-[44px] flex-center border-none cursor-pointer transition-300-ease bg-[rgba(176,176,176,0.5)] text-[rgba(48,48,48,1)] hover:bg-[rgba(176,176,176,0.3)] hover:text-[rgba(26,26,26,1)] rounded-[22px]'>{t('THREEWRAPPER_CANCEL')}</button>
                <button onClick={useVoxel} className='w-[159px] h-[44px] flex-center border-none cursor-pointer [background:linear-gradient(180deg,_#6D49FF_0%,_#A347FF_100%)] hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)] text-[#fff] rounded-[22px]'>{t('THREEWRAPPER_USE_VOXEL')}</button>
            </div>
            <div onClick={confirm} className='text-[rgba(136,136,136,1)] hover:text-[rgba(45,45,45,1)] transition-300-ease text-[14px] cursor-pointer relative after:content-[""] after:absolute after:bottom-[-1px] after:left-0 after:w-[0px] after:h-[1px] after:bg-[rgba(136,136,136,1)] after:transition-300-ease hover:after:w-full'>{t('THREEWRAPPER_BUTTON_CONFIRM')}</div>
        </div>)
    }

    const handleConfirmBoxSize = async () => {
        if (loading) return
        if (!threeController.current?.originMesh && !threeController.current?.instancedMesh) {
            tip({
                content: t('TIP_WRAN_THREEWRAPPER_DROP_MODEL'),
                type: 'warning',
            })
            return
        }
        setOpenThreeBoxSelector(false)
        setOpenThreeWrapper(pre => ({
            ...pre,
            status: false
        }))
        setOpenRange(false)
        threeController.current.confirmCondition()
        threeController.current.canResize = false
        setMeshParameters(prev => {
            return meshKeys.reduce((acc, key, index) => {
                const isActive = index === activeIndex;
                let params = prev[key].params;
                let pos = prev[key].pos;

                if (isActive) {
                    if (activeIndex === 1) {
                        params = threeController.current.voxelsCache[threeController.current.newVoxelIndex].params;
                        pos = threeController.current.voxelsCache[threeController.current.newVoxelIndex].voxels;
                    } else if (activeIndex === 2) {
                        params = threeController.current.pointsCache[threeController.current.newPointsIndex].params;
                        pos = threeController.current.pointsCache[threeController.current.newPointsIndex].points;
                    } else if (activeIndex === 0) {
                        params = [...Object.values(prev[key].pos), 1]
                    }
                }

                const updatedState = {
                    ...acc,
                    [key]: {
                        ...prev[key],
                        confirmed: isActive,
                        params: params,
                        pos: pos,
                        ...(activeIndex === 1 && {
                            voxel_condition_cfg: voxelMode,
                            voxel_condition_weight: voxelScale
                        }),
                        ...(activeIndex === 2) && {
                            pcd_condition_uncertainty: pcdUncertainty
                        }
                    }
                };

                return updatedState;
            }, {});
        });

        // setUploadStatus(false)
    }

    const handleClearModel = (e) => {
        e && e.stopPropagation()
        if (loading) return
        if (threeController?.current?.isAnimation) {
            tip({ content: t('TIP_WRAN_THREEWRAPPER_VOXEL_COMPLETE'), type: 'warning' });
            return;
        }
        threeController.current.clearModel()
        setOpenThreeWrapper(pre => ({
            ...pre,
            upload: true
        }))
        threeController.current.canResize = false
        // setCondition(true)
        // setUploadStatus(true)
    }

    const handleResetCamera = () => {
        if (loading) return
        threeController.current.mainScene.restoreCameraInitialPos()
    }

    useEffect(() => {
        if (!openThreeWrapper.status) {
            setDirectionIndex(-1)
            setOpenRange(false)
            setOpenDirectWrapper(false)
        }
    }, [openThreeWrapper.status])

    const handleCloseThree = () => {
        if (activeIndex === 1) {
            if (meshValues[1].confirmed) {
                setVoxelScale(meshValues[1].voxel_condition_weight)
                setVoxelMode(meshValues[1].voxel_condition_cfg)
            } else {
                setVoxelScale(1.0)
                setVoxelMode(true)
            }
        } else if (activeIndex === 2) {
            setPcdUncertainty(meshValues[2].pcd_condition_uncertainty)
        }
        if (threeController?.current?.originMesh) {
            threeController.current.originMesh.visible = false
        }
        if (threeController?.current?.instancedMesh) {
            threeController.current.instancedMesh.visible = false
        }
        setOpenThreeWrapper(pre => ({
            ...pre,
            status: false
        }))
        setOpenRange(false)
        setOpenThreeBoxSelector(false)
        if (threeController?.current) {
            threeController.current.canResize = false
        }
    }

    const handleFileInputChange = (e) => {
        const files = [...e.target.files];
        handlerFiles(files[0]);
        e.target.value = '';
    };

    const handlerFiles = (file) => {
        //恢复默认scale值
        // setNoModel(false)
        restoreDefaultData()
        if (openThreeWrapper.upload) {
            handleOpenBoundingBox(file, activeIndex, openThreeBoxSelector ? bboxRefArr[activeIndex] : bboxConfirmedRefArr[activeIndex], false)
        } else {
            setLoading(true)
            boundingWrapperRef.current?.clientHeight  // 强制渲染一次
            setTimeout(() => {
                threeController.current.editorpageUpdateMesh(meshKeys[activeIndex], file)
            }, 50);
        }
    }

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFileDropHover(true);
    }

    const handleDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFileDropHover(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFileDropHover(false);
    };

    const handleFileDrop = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        // if (!logInfo) {
        //     setShowLogin(true);
        //     return;
        // }
        if (threeController?.current?.isAnimation) {
            tip({ content: t('TIP_WRAN_THREEWRAPPER_VOXEL_COMPLETE'), type: 'warning' });
            return;
        }
        setFileDropHover(false);
        const file = [...event.dataTransfer.files][0];
        if (!file) {
            tip({
                content: 'Please upload a file', // i18n translation needed
                type: "error"
            });
            return;
        }
        const ALLOWED_FORMATS = ['glb', 'fbx', 'gltf', 'obj', 'dae', 'stl', 'ply'];
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!ALLOWED_FORMATS.includes(fileExtension)) {
            tip({
                content: t('TIP_ERR_MODELS_FORMATS'),
                type: "error"
            });
            return;
        }


        handlerFiles(file);
    };

    const recalculatePos = () => {
        if (openThreeWrapper) {
            setTimeout(() => {
                let eTarget = openThreeBoxSelector ? bboxRefArr[activeIndex].current : bboxConfirmedRefArr[activeIndex].current
                if (eTarget) {
                    const { left, top } = eTarget.getBoundingClientRect()
                    setOpenThreeWrapper(pre => (
                        {
                            ...pre,
                            left: left,
                            top: top
                        }
                    ))
                }
            }, 1000);
        }
    }

    useEffect(() => {
        if (threeController.current) {
            window.addEventListener('resize', recalculatePos)
        }
        return () => {
            if (!threeController.current) {
                window.removeEventListener('resize', recalculatePos)
            }
        }
    }, [threeController.current])

    const handleOpenThreeBoxSelector = () => {
        if (xscrollRef.current && xscrollRef.current.xcrolling) return
        openThreeBoxSelectortimerRef.current = setTimeout(() => {
            setOpenThreeBoxSelector(true)
        }, 200)
    }

    const handlePauseOpenThreeBoxSelector = () => {
        if (openThreeBoxSelectortimerRef.current) {
            clearTimeout(openThreeBoxSelectortimerRef.current)
            openThreeBoxSelectortimerRef.current = null
        }
    }

    const handleCloseThreeByMouseLeave = () => {
        if (openThreeWrapper.status) return
        if (openThreeBoxSelectortimerRef.current) {
            clearTimeout(openThreeBoxSelectortimerRef.current)
            openThreeBoxSelectortimerRef.current = null
        }
        setOpenThreeBoxSelector(false)
    }

    const handleCloseThreeBoxSelector = () => {
        setOpenThreeBoxSelector(false)
    }

    const handleOpenSculpt = async () => {
        if (threeController?.current?.exportOBJ) {
            const dbName = 'SculptGL';
            const storeName = 'SculptGL';
            const db = await initDB(dbName, storeName);
            await db.put(storeName, threeController.current.exportOBJ, 'SculptGLFile');
            const SculptGLInfo = {
                origin: window.location.origin + "/rodin/" + taskDetail?.task_uuid,
                task_uuid: taskDetail?.task_uuid,
                symmetric: null,
                modelUrl: null,
                type: "condition",
                activeIndex: activeIndex,
                initmodel: true,
                status: "editor",
            }
            sessionStorage.setItem('SculptGLInfo', JSON.stringify(SculptGLInfo))
            window.location.href = `${window.location.origin}/proxy/rodin/MeshEditor/?env=netease`;
        }
    }

    const initDB = async (dbName, storeName) => {
        const db = await openDB(dbName, 1, {
            upgrade(db) {
                db.createObjectStore(storeName);
            },
        });
        return db;
    }

    useEffect(() => {
        if (showOptSubLinkTip) {
            optSubLinkTipRef.current = setInterval(() => {
                setShowOptSubLinkTip(false)
                clearInterval(optSubLinkTipRef.current)
            }, 3000)
        } else {
            if (optSubLinkTipRef.current) {
                clearInterval(optSubLinkTipRef.current)
            }
        }

        return () => {
            if (optSubLinkTipRef.current) {
                clearInterval(optSubLinkTipRef.current)
            }
        }
    }, [showOptSubLinkTip])

    useEffect(() => {
        if (showSubLinkTip !== false && showSubLinkTip >= 0) {
            showSubLinkTipRef.current = setInterval(() => {
                setShowSubLinkTip(false)
                clearInterval(showSubLinkTipRef.current)
            }, 3000)
        } else {
            if (showSubLinkTipRef.current) {
                clearInterval(showSubLinkTipRef.current)
            }
        }

        return () => {
            if (showSubLinkTipRef.current) {
                clearInterval(showSubLinkTipRef.current)
            }
        }
    }, [showSubLinkTip])

    const handle3dconditionUpload = () => {
        fileInputRef.current.click()
    }

    const handle3dconditionHandcraft = () => {
        if (activeIndex === 0) {
            handleOpenBoundingBox(null, 0, openThreeBoxSelector ? bboxRefArr[activeIndex] : bboxConfirmedRefArr[activeIndex], false)
        } else {
            openMeshEditor()
        }
    }

    const openMeshEditor = () => {
        const SculptGLInfo = {
            origin: window.location.origin + "/rodin/" + taskDetail?.task_uuid,
            task_uuid: taskDetail?.task_uuid,
            symmetric: null,
            modelUrl: null,
            type: "condition",
            activeIndex: activeIndex,
            status: "editor",
        }
        sessionStorage.setItem('SculptGLInfo', JSON.stringify(SculptGLInfo))
        window.location.href = `${window.location.origin}/proxy/rodin/MeshEditor/?env=netease`;
    }

    useEffect(() => {
        if (conditionReady.self && conditionReady.other) {
            const SculptGLInfo = JSON.parse(sessionStorage.getItem('SculptGLInfo'))
            if (SculptGLInfo?.file && SculptGLInfo?.status === 'editor' && SculptGLInfo?.type === 'condition') {
                const dbName = 'SculptGL';
                const storeName = 'SculptGL';
                initDB(dbName, storeName).then(async (db) => {
                    const modelFile = await db.get(storeName, 'SculptGLFile');
                    modelFile.isMeshEditor = true
                    // const a = document.createElement('a');
                    // const blob = new Blob([modelFile], { type: 'text/plain' });
                    // a.href = URL.createObjectURL(blob);
                    // a.download = 'SculptGL.obj';
                    // a.click();
                    setOpenThreeBoxSelector(true)

                    if ([1, 2].includes(SculptGLInfo.activeIndex)) {
                        setMeshParameters(prev => {
                            return {
                                ...prev,
                                [meshKeys[SculptGLInfo.activeIndex]]: {
                                    ...prev[meshKeys[SculptGLInfo.activeIndex]],
                                    wlhparams: { x: 1, y: 1, z: 1 }
                                }
                            }
                        });
                        if (SculptGLInfo.activeIndex === 1) {
                            setTimeout(() => {
                                handleOpenBoundingBox(modelFile, 1, bboxRefArr[1], true)
                                sessionStorage.removeItem('SculptGLInfo')
                            }, 300);
                        } else if (SculptGLInfo.activeIndex === 2) {
                            setTimeout(() => {
                                handleOpenBoundingBox(modelFile, 2, bboxRefArr[2], true)
                                sessionStorage.removeItem('SculptGLInfo')
                            }, 300);
                        }
                    }
                })
            }
        }

    }, [conditionReady])

    useEffect(() => {
        if (threeController.current) {
            restoreDefaultData()
            threeController.current.pointsTotalSum = SAMPLING_ARRAY[samplingVal]
            threeController.current.regeneratePCDbySampling()
        }
    }, [samplingVal])

    const restoreDefaultData = () => {
        setShowDirectRange(false)
        setDirectionIndex(-1)
        setSliderValue([0, 0, 0])
        if (['voxel', 'pointCloud'].includes(meshKeys[activeIndex])) {
            setMeshParameters(prev => {
                return {
                    ...prev,
                    [meshKeys[activeIndex]]: {
                        ...prev[meshKeys[activeIndex]],
                        wlhparams: { x: 1, y: 1, z: 1 }
                    }
                }
            });

            if (meshKeys[activeIndex] === 'voxel') {
                setVoxelScale(1.0)
                setVoxelMode(true)
                setVoxelSymmetric(false)
            } else {
                setPcdUncertainty(0.01)
            }
        }
    }

    const handleSetSampling = (index) => {
        if (threeController.current && threeController.current.isAnimation) {
            tip({ content: t('TIP_WRAN_THREEWRAPPER_VOXEL_COMPLETE'), type: 'warning' });
            return
        }
        if (!threeController.current?.currentObeject.file) {
            tip({ content: t('TIP_WRAN_THREEWRAPPER_NEWLY_MODELS'), type: 'warning' });
            return
        }
        setSamplingVal(index)
    }

    const setVoxelRangeVal = (val) => {
        setVoxelScale(val)
    }

    const handleSetVoxelCfg = (val) => {
        setVoxelMode(val)
    }

    const setRangeVal = (val) => {
        if (threeController.current) {
            threeController.current.pcdUncertainty = val
        }
        setPcdUncertainty(val)
    }
    const handleOpenDirectWrapper = () => {
        if (directionWrapperCloseFlag) {
            setOpenDirectWrapper(true)
            setDirectionWrapperCloseFlag(false)
        }
    }

    const handleCloseDirectWrapper = () => {
        setOpenDirectWrapper(false)
        setTimeout(() => {
            setDirectionWrapperCloseFlag(true)
        }, 100);
    }

    const handleToggleDirection = (index) => {
        setDirectionIndex(index)
        setTimeout(() => {
            setDirectionWrapperCloseFlag(true)
        }, 100);
        if (index === 0) {
            handleResetCamera()
        } else {
            handleSwitchOrthoCamera(index - 1)
            setOpenDirectWrapper(false)
        }
    }

    const handleSwitchOrthoCamera = (index) => {
        if (loading) return
        setShowDirectRange(true)
        // openDirectionGIF(index)
        threeController.current.mainScene.switchOrthoCamera(threeController.current.recordOriginalMeshRotationAfterOrthoCameraUpdated.bind(threeController.current), index);
    }

    useEffect(() => {
        showDirectRangeRef.current = showDirectRange
    }, [showDirectRange])

    const handleQuitOrthCamera = () => {
        if (showDirectRangeRef.current) {
            setShowDirectRange(false)
            setDirectionIndex(-1)
        }
    }

    const handleSliderChange = (newValue) => {
        const newSliderValue = [...sliderValue]
        newSliderValue[directionIndex - 1] = +newValue;
        setSliderValue(newSliderValue);
        updateModelBasedOnSlider(newSliderValue);
    };

    useEffect(() => {
        if (updated && threeController.current) {
            threeController.current.updateMeshByRotate()
            setTimeout(() => {
                setUpdated(false)
            }, 100);
        }
    }, [updated])

    const stopRotate = () => {
        if (threeController.current && threeController.current.isAnimation) {
            tip({ content: t('TIP_WRAN_THREEWRAPPER_MODEL_ROTATING'), type: 'warning' });
            return true
        }
    }

    const updateModelBasedOnSlider = (newSlider) => {
        const value = newSlider[directionIndex - 1]
        threeController.current && threeController.current.updateOriginalMeshRotationAxisAligned(-value);
    };

    useEffect(() => {
        showDirectRangeRef.current = showDirectRange
    }, [showDirectRange])

    const handleToggleVoxelSymmetric = (e) => {
        if (symmetricRef.current && symmetricRef.current.contains(e.target)) return
        setVoxelSymmetric(pre => !pre)
        threeController.current.reCaculateDepthMap2Pos(!voxelSymmetric)
    }

    const handleSimplify = (e) => {
        e.stopPropagation()
        setRawCheck(true)
        setCurrentPolygonsIndex(-2)
        setSimplifyCheck((old) => !old)
        if (currentPolygonsIndex !== -2) {
            setPrePolygonsIndex(currentPolygonsIndex)
        }
    }

    const handleSmooth = (e) => {
        e.stopPropagation();
        if (currentPolygonsIndex === -2) {
            setCurrentPolygonsIndex(prePolygonsIndex)
        }
        setSmoothCheck((old) => !old)
    }

    const handleAsymmetry = (e) => {
        e.stopPropagation();
        setAsymmetryCheck((old) => !old);
    };

    const meshEntryName = [{
        name:'Bounding Box',
        entryName:t('THREEWRAPPER_BOUNDINGBOX')
      },{
        name:'bounding box',
        entryName:t('THREEWRAPPER_SMALL_BOUNDINGBOX')
      },{
        name:'Voxel',
        entryName:t('THREEWRAPPER_VOXEL')
      },{
        name:'voxel',
        entryName:t('THREEWRAPPER_SMALL_VOXEL')
      },{
        name:'Point Cloud',
        entryName:t('THREEWRAPPER_POINTCLOUD')
      },{
        name:'point cloud',
        entryName:t('THREEWRAPPER_SMALL_POINTCLOUD')
    }]

    const proCheck = (checked) =>{
        setOpenProCheck(false)
        if (checked) {
            setCurrentPolygonsIndex(-2)
        }
        localStorage.setItem('proCheck',true)
        setProChange(true)
    }

    useEffect(()=>{
        if(proChange){
            handleConfirmOrGenerate(null, false)
        }
    },[proChange])

    return (
        <div ref={ref} className={style.geometryWrapper}>
            <div onClick={(e)=>{
                    if (proCheckRef.current.contains(e.target)) {
                        return;
                    } else {
                        setOpenProCheck(false)
                    }
                }} className={`fixed  w-[100%] h-[100%] z-[99999] top-0 left-0 flex justify-center items-center ${openProCheck ? ' opacity-100 visible' : 'animation-face-check'}`}>
                <div ref={proCheckRef} className={`px-[27px] py-[20px] max-w-[390px] gap-[12px] font-[Arial] [box-shadow:0px_0px_44px_0px_#6A33DE79] flex flex-col [transition:all_0.3s_cubic-bezier(0.23,1,0.32,1)]  ${openProCheck ? ' opacity-100 visible scale-100' : ' opacity-0 invisible scale-0'} bg-[rgba(255,255,255,0.8)] backdrop-blur-[50px] rounded-2xl [box-shadow:0px_0px_12px_0px_rgba(74,0,224,0.15)]`}>
                    <span className='text-[20px] font-bold text-[#883AF5]'>{t('RODIN_PRO_OPEN_TITLE')}</span>
                    <div className={`gap-[var(--smGap)] w-full h-auto flex flex-row justify-between`}>
                        <div className='w-[18%] h-auto aspect-square bg-[rgb(238,238,238)] rounded-[12px] overflow-hidden'>
                            <img className='w-full' src={rawcheckIcon} />
                        </div>
                        <div className={`group/raw [contain:layout] overflow-hidden relative flex flex-col items-start justify-between w-[79%] h-auto py-[2.5%] px-[4%] border-[1px] border-solid rounded-[12px] [transition:border-color_0.3s_ease]
                        border-[#7B42F6] text-[rgb(123,66,246)] bg-[rgb(246,242,255)]`}>
                            <div className='w-full [contain:layout] h-auto flex flex-row items-center justify-between'>
                                <span className='text-[var(-midFs)] leading-[var(-midFs)]'>{t('RODIN_PRO_MODE')}</span>
                                <label onClick={handleSimplify} className={`cursor-pointer -mt-[6px] h-full flex flex-row items-center gap-[2px] [transition:opacity_0.3s_ease] [font-size:var(--smFs)] leading-[var(--smFs)] [@media_(max-height:1080px)]:[font-size:11px] [@media_(max-height:1080px)]:leading-[11px] font-normal`} >
                                    <span className={`${style.checkmark} ${style.current} ${simplifyCheck ? style.checked : ''}`}></span>
                                    <span className='flex items-center gap-[1px] relative'>{t('RODIN_PRO_SIMPLIFY')}</span>
                                </label>
                            </div>
                            <div className={`w-full [contain:layout] flex items-center justify-between`}>
                                <div
                                    className={`font-normal whitespace-nowrap [font-size:var(--smFs)] leading-[var(--smFs)] text-left [font-style:normal] normal-case select-none flex items-center gap-[5px] [transition:border-color_0.3s_ease]`}>
                                    <div className={`w-[12px] h-[12px] rounded-full [transition:border-color_0.3s_ease] flex items-center justify-center relative
                                    [border:1px_solid_#7B42F6]`}>
                                        <span className={`w-full h-full rounded-full [border:1px_solid_rgb(246,242,255)] [transition:border-color_0.3s_ease]
                                        opacity-100 visible bg-[rgb(123,66,246)]`}></span>
                                    </div>
                                    {t('RODIN_PRO_TIP')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex flex-row justify-between pt-[5px]'>
                        <button onClick={()=>{proCheck(false)}} className='w-[48%] py-[8px] [transition:all_0.3s_ease] bg-[rgba(238,238,238,1)] hover:bg-[rgba(238,238,238,0.7)] rounded-[35px] font-bold text-[rgb(172,172,172)]'>{t('RODIN_PRO_OPEN_KEEP')}</button>
                        <button onClick={()=>{proCheck(true)}} className='w-[48%] py-[8px] [transition:all_0.3s_ease] bg-[linear-gradient(180deg,#6D49FF_0%,#A347FF_100%)] hover:bg-[linear-gradient(272.06deg,#B166FB_0%,#795EFC_50%,#8067FD_100%)] font-bold rounded-[35px] text-white'>{t('RODIN_PRO_OPEN_TRY')}</button>
                    </div>
                </div>
            </div>
            <div className={style.geometryHeader}>
                <div className={style.geometryTitle}>{t('RODIN_GENERTAE_BOARD_GEO_TITLE')}</div>
                {!isDone && stage !== STAGE_ENUM.GENERATING && <History />}
                {taskDetail?.step === 'ModelRefine' && taskDetail?.author?.user_uuid === localStorage.getItem('user_uuid') && isMtlGeneratingRef.current && (
                    <div
                        className='group/editor hover:bg-[rgba(74,0,224,0.05)] transition-300-ease z-[1000] px-[8px] gap-1 rounded-[52px] flex items-center cursor-pointer '
                        onClick={handleOpenEdit}>
                        <div className='group-hover/editor:opacity-100 transition-300-ease opacity-[0.6] w-[16px] h-[16px]'>
                            <img className='w-full h-full' src={editor} alt="editor" />
                        </div>
                        <span className=' text-[rgba(74,0,224,1)] text-sm'>{t('BUTTON_MESH_EDITOR')}</span>
                    </div>
                )}
            </div>
            <div className={style.geometryBody} >
                {stage === STAGE_ENUM.GENERATING && <div className={style.diableMask}></div>}
                <div className={`
                ${style.textPromptArea} 
                ${isDone && (style.textPromptLocked)}
                ${optionOpen ? "z-[10]" : "z-[2]"}`}>
                    <textarea
                        className={style.geometryTextArea}
                        placeholder={t('RODIN_GENERTAE_BOARD_GEO_TEXT_AREA')}
                        value={promptText}
                        onChange={handlePromptTextChange}
                        disabled={isDone}
                    ></textarea>
                    <div className={`gap-1 md:gap-2 relative z-[2]
                    ${style.xsrollPrompt} 
                    ${isDone && (style.promptLocked)} 
                    ${openThreeBoxSelector ? style.openThreeBoxSelector : ""}
                    ${openThreeWrapper.status ? style.openthree : ""}
                    `}
                        onMouseLeave={handleCloseThreeByMouseLeave}
                    >
                        <div className={`absolute left-0 top-0 bg-[rgba(0,0,0,0.25)] z-[0] overflow-hidden rounded-[22px] transition-300-ease h-full
                            ${openThreeBoxSelector ? "opacity-100 pointer-events-auto w-full" : "opacity-0 pointer-events-none w-0"}`}>
                            <div className={`bg-[rgba(162,45,255,0.6)] blur-3xl w-1/2 h-[auto] aspect-square absolute left-[5%] bottom-[-80%]`}></div>
                            <div className={`bg-[rgba(87,45,255,0.6)] blur-3xl w-1/2 h-[auto] aspect-square absolute right-[5%] top-[-80%]`}></div>
                        </div>
                        {!isDone && logInfo && (
                            <div className={`flex gap-1 h-full items-center relative pr-1 md:pr-2 z-[1] ${style.bboxWrapper} ${openThreeBoxSelector ? style.openThreeBoxSelector : ""}`}>
                                <div className="h-[85%] sm:h-[90%] md:h-full w-auto aspect-square rounded-full flex-center relative cursor-pointer"
                                    onMouseEnter={handleOpenThreeBoxSelector}
                                    onMouseLeave={handlePauseOpenThreeBoxSelector}>
                                    <img className={`${openThreeBoxSelector ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"} w-[90%] h-[90%] transition-300-ease`} src={bboxicon} alt="bboxicon" />
                                    <div onClick={handleCloseThreeBoxSelector} className={`${openThreeBoxSelector ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} flex-center absolute-center w-[90%] h-[90%]  rounded-full transition-300-ease cursor-pointer`}>
                                        {/* <span className='w-[10px] h-[10px] relative left-[2px] border-[3px] border-[#4a00e0] [transform:rotate(-45deg)] [transform-origin:50%_50%] [border-right-color:transparent] [border-bottom-color:transparent] rounded-[2px]'></span> */}
                                        <img className='w-[50%] h-auto relative left-[-2px]' src={backarrow} alt="backarrow" />
                                    </div>
                                </div>
                                {meshValues.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {(
                                            <div
                                                style={{ display: item.confirmed ? "block" : "none" }}
                                                ref={bboxConfirmedRefArr[index]}
                                                onClick={handleCheckConfirmedStatus.bind(null, null, index, bboxConfirmedRefArr[index])}
                                                className={`flex items-center text-[10px] md:text-[14px] transition-300-ease border border-transparent  bg-[transparent]
                                        ${!openThreeBoxSelector ? "h-[85%] sm:h-[90%] md:h-full opacity-100" : "h-0 opacity-0"}
                                        ${style.bboxitem} 
                                        ${item.confirmed ? "hover:border-[#4a00e0]" : "hover:border-[#fff]"}`}>
                                                <div className={`rounded-full transition-300-ease w-auto aspect-square h-full flex ${!openThreeBoxSelector ? "bg-[rgba(74,0,224,0.1)]" : ""}`}>
                                                    <img className='w-[60%] h-[60%] relative m-auto' src={item.icon} alt={item.name} />
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}
                        <div className={style.rightcontent}>
                            {/* <div className={`${style.xscrolleasyWrapper} ${openThreeBoxSelector ? style.openThreeBoxSelector : ""}`}>
                                <XscrollEasy fullHeight disableScrollingDom={bodyRef.current} ref={xscrollRef}>
                                    <div className={style.promptWrapper}>
                                        {chosenList.length === 0 && isDone ? (
                                            <div className={style.placeholder} />
                                        ) : (
                                            presetPrompts
                                                .map((item, index) => {
                                                    const isSelected = chosenList.includes(index);
                                                    if (isDone && !isSelected) {
                                                        return null;
                                                    }
                                                    if(optionChange && item === 'Sharp'){
                                                        return
                                                    }
                                                    return (
                                                        <div key={index}
                                                            className={`${style.propmtItem} ${isSelected && (!isDone ? ((item === 'T/A Pose' || item === 'Sharp') ? style.tachoosed : style.choosed) : ((item === 'T/A Pose' || item === 'Sharp') ? style.tachoosed : style.locked))}
                                                            ${xscrollRef.current && xscrollRef.current.xcrolling ? "" : "hover:bg-[#d7d7d7]"}`}
                                                            onClick={!isDone ? handlerChoosePrompt.bind(null, index, item) : undefined}
                                                        >

                                                            <span className={`flex flex-row relative items-center gap-[2px] ${!isDone && ((item === 'T/A Pose' || item === 'Sharp') ? isSelected ? 'bg-transparent text-white' : 'bg-[linear-gradient(90deg,#886FCC_0%,#4597D5_100%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]' : '')}`}>
                                                                {(item === 'T/A Pose' || item === 'Sharp') && <div className='h-full w-[12px]'><img className='h-full w-full' src={isSelected ? tacheckicon : taicon} /></div>}
                                                                {(item === 'T/A Pose' || item === 'Sharp') ? item : item === 'sharp edges'? item.split(' ')[1]:item.split(' ')[0]}
                                                            </span>
                                                            {!isDone && item === 'T/A Pose' && isSelected && <span className={`absolute h-[120%] w-[30px]  bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.1)_25%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.1)_75%,rgba(255,255,255,0)_100%)] [clip-path:polygon(25%_0%,100%_0%,75%_100%,0%_100%)] at-animation`}></span>}
                                                        </div>
                                                    )
                                                })
                                        )}
                                    </div>
                                </XscrollEasy>
                            </div> */}
                            <div className={`${style.xscrolleasyWrapper} ${openThreeBoxSelector ? style.openThreeBoxSelector : ""}`}>
                                <Swiper
                                    ref={swiperRef}
                                    modules={[Mousewheel, FreeMode]}
                                    direction="horizontal"
                                    grabCursor={true}
                                    mousewheel={{
                                        invert: false
                                    }}
                                    freeMode={{
                                        enabled: true,
                                        sticky: false,
                                        momentum: true
                                    }}
                                    slidesPerView="auto"
                                    spaceBetween={8}
                                    className={`w-full h-full `}
                                >
                                    <SwiperSlide className="!w-auto">
                                        {/* {console.log(presetPrompts, 'presetPrompts')} */}
                                        <div className={style.promptWrapper}>
                                            {chosenList.length === 0 && isDone ? (
                                                <div className={style.placeholder} />
                                            ) : (
                                                presetPrompts.map((item, index) => {
                                                    const isSelected = chosenList.includes(index);
                                                    if (isDone && !isSelected) {
                                                        return null;
                                                    }
                                                    if (!optionSharp && optionChange && item === 'Sharp') {
                                                        return
                                                    }
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`${style.propmtItem} ${isSelected && (!isDone ? ((item === 'T/A Pose' || item === 'Sharp') ? style.tachoosed : style.choosed) : ((item === 'T/A Pose' || item === 'Sharp') ? style.tachoosed : style.locked))
                                                                } hover:bg-[#d7d7d7]`}
                                                            onClick={!isDone ? handlerChoosePrompt.bind(null, index, item) : undefined}
                                                        >
                                                            <span className={`flex flex-row relative items-center gap-[2px] ${!isDone && ((item === 'T/A Pose' || item === 'Sharp') ? isSelected ? 'bg-transparent text-white' : 'bg-[linear-gradient(90deg,#886FCC_0%,#4597D5_100%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]' : '')}`}>
                                                                {(item === 'T/A Pose' || item === 'Sharp') && <div className='h-full w-[12px]'><img className='w-[90%]' src={isSelected ? tacheckicon : taicon} /></div>}
                                                                {(item === 'T/A Pose' || item === 'Sharp') ? promptList[item] : item === 'sharp edges' ? item.split(' ')[1] : item.split(' ')[0]}
                                                            </span>
                                                            {!isDone && (item === 'T/A Pose' || item === 'Sharp') && isSelected && <span className={`absolute h-[120%] w-[30px]  bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.1)_25%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.1)_75%,rgba(255,255,255,0)_100%)] [clip-path:polygon(25%_0%,100%_0%,75%_100%,0%_100%)] at-animation`}></span>}
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                            <div className={`${style.bboxmain} ${openThreeBoxSelector ? style.openThreeBoxSelector : ""} transition-300-ease gap-1 lg:gap-2`}>
                                {meshValues.map((item, index) => (
                                    <div
                                        key={index}
                                        ref={bboxRefArr[index]}
                                        onClick={handleCheckConfirmedStatus.bind(null, null, index, bboxRefArr[index])}
                                        className={`
                                           group/outer  text-[10px] sm:text-[12px] lg:text-[14px] p-[3px]  gap-1 lg:gap-2  transition-300-ease
                                            ${style.bboxitem} 
                                            ${meshValues[index].confirmed ? style.confirmed : style.unconfirmed}
                                            ${index === 1 ? style.borderWrapper : ""}
                                            ${meshValues[index].confirmed ? " pr-[6px]" : "]"}`}>
                                        <div className={`rounded-full h-[90%] w-auto aspect-square flex-center bg-[rgba(255,255,255,0.3)] transition-300-ease group-hover/outer:bg-[rgba(255,255,255,0.35)] backdrop-blur-lg`}>
                                            <img className='relative group-hover/outer:[transform:scale(1.1)] transition-300-ease w-[60%] h-[60%] m-auto' src={item.icon} alt={item.name} />
                                        </div>
                                        <span className='w-max text-[#fff]'>{meshEntryName.filter(items=>items.name===item.name)[0]?.entryName}</span>
                                        <div
                                            onClick={cancelConfirmed.bind(null, index)}
                                            ref={comfirmedIconRef}
                                            className={`group/inner
                                            ${style.checkedIcon}
                                            ${meshValues[index].confirmed ? "" : "[border:1px_solid_#4a00e0]"}
                                            ${meshValues[index].confirmed ? style.confirmed : style.unconfirmed}`}>
                                            {/* <span></span> */}
                                            <img
                                                className={`transition-300-ease ${meshValues[index].confirmed ? "absolute inset-0 opacity-100 group-hover/outer:opacity-0" : "opacity-0"}`}
                                                src={confirmedIcon}
                                                alt="confirmedIcon"
                                            />
                                            <img
                                                className={`${meshValues[index].confirmed ? "absolute inset-0 opacity-0 group-hover/outer:opacity-100 group-hover/inner:!opacity-0" : "opacity-0"}`}
                                                src={delete_default}
                                                alt="delete_default"
                                            />
                                            <img
                                                className={`${meshValues[index].confirmed ? "absolute inset-0 opacity-0 group-hover/inner:opacity-100" : "opacity-0"}`}
                                                src={delete_hover}
                                                alt="delete_hover"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {<ThreeJSOverlay close={handleCloseThree} dragging={dragging} rangeDragging={rangeDragging} openThreeWrapper={openThreeWrapper}>
                                <div
                                    style={{
                                        top: `${openThreeWrapper.top * 1.02 + 48}px`,
                                        left: openThreeWrapper.left - 2 + "px",
                                    }}
                                    className={`absolute [box-shadow:0px_2px_16px_0px_rgba(74,0,224,0.15)] rounded-2xl p-[3px] flex flex-col justify-between items-center bg-[#fff] [transform:translateY(calc(-100%+30px))] pointer-events-auto
                                    ${fileDropHover && !openThreeWrapper.upload ? "[outline:3px_dashed_#4a00e0]" : "[outline:3px_dashed_transparent]"}
                                    ${threeController.current ? "[transition:left_0.3s_ease,top_0.3s_ease,height_0.3s_ease,opacity_0.3s_ease,width_0.3s_ease,outline_0.3s_ease;]" : ""}
                                    ${openThreeWrapper.status
                                            ? openThreeWrapper.upload
                                                ? "opacity-100 w-[308px] h-[223px] pointer-events-auto"
                                                : (activeIndex === 0
                                                    ? "opacity-100 w-[298px] h-[213px] md:w-[308px] md:h-[233px] pointer-events-all"
                                                    : "opacity-100 w-[298px] h-[243px] md:w-[308px] md:h-[293px] pointer-events-all")
                                            : "opacity-0 w-[60px] h-[30px] pointer-events-none"}`}>
                                    <div
                                        onDrop={handleFileDrop}
                                        onDragOver={handleDragOver}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        className={`relative w-[calc(100%-4px)] h-full rounded-[12px] overflow-hidden
                                            ${style.webglcontainer} ${openThreeWrapper.status && openThreeWrapper.upload ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"}`}
                                        ref={boundingBoxRef}>
                                        <div className='absolute select-none top-0 right-0 py-2 px-[8px] flex flex-col justify-center items-center gap-2 text-xs'>
                                            {!noModel && (
                                                <div
                                                    ref={directWrapperRef}
                                                    onMouseEnter={handleOpenDirectWrapper}
                                                    onMouseLeave={handleCloseDirectWrapper}
                                                    className={`group/direction w-[30px] h-[30px] relative z-10 cursor-pointer transition-300-ease rounded-full  backdrop-blur-[10px]
              ${directionAnimation && style.directAnimation}
              ${directionIndex !== -1 && style.directChecked}
              ${directionIndex !== -1 ? "bg-[rgba(40,221,232,0.1)]" : "bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.3)]"}`}>
                                                    <div className={` transition-300-ease w-full h-full relative z-10 rounded-full flex-center
                ${!openDirectWrapper ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
                ${style.target}`} >
                                                        <Svg src={directionIndex === -1 ? defaultDirect : svgArray[directionIndex].src}></Svg>
                                                    </div>
                                                    {/* <img className='group-hover/direction:opacity-0 transition-300-ease w-full h-full relative z-10 ' src={resetFront} alt="resetFront" /> */}
                                                    <span className={`absolute flex-center  whitespace-nowrap z-0 top-0 right-0 h-full bg-[rgba(255,255,255,0.1)] rounded-[12px] leading-[30px] text-white text-[12px] pl-[12px] pr-[30px]
                  ${directionAnimation ? style.directionText : "invisible pointer-events-none"}`}>
                                                        {t('THREEWRAPPER_ROTATE_MODEL_RESULTS')}
                                                    </span>
                                                    <div
                                                        className={`absolute h-[30px] top-[0px] right-[0px] z-[200] flex items-center gap-[3px] px-[3px] rounded-[14px]  transition-300-ease
                ${openDirectWrapper ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
                ${style.svgBoxWrapper}`}
                                                    >
                                                        {svgArray.map((item, index) => (
                                                            <div
                                                                className={`w-[28px] h-[28px] transition-300-ease flex-center rounded-full hover:bg-[rgba(40,221,232,0.1)] relative cursor-pointer
                  ${[0, 1, 2].includes(index) ? style.svgBoxBorder : ""}
                  ${directionIndex === index ? style.svgBoxChecked : ""}
                  ${style.svgBox}`}
                                                                key={index}
                                                                onClick={handleToggleDirection.bind(null, index)}>
                                                                <Svg src={item.src} />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )
                                            }

                                            <div onClick={handleClearModel} className='w-[30px] h-[30px] flex-center cursor-pointer hover:bg-[rgba(255,255,255,0.3)] transition-300-ease rounded-full bg-[rgba(255,255,255,0.1)] backdrop-blur-[10px]'>
                                                <AiOutlineClear fontSize={16} />
                                            </div>
                                            {activeIndex === 1 && (
                                                <div
                                                    onClick={handleToggleVoxelSymmetric}
                                                    className={`group/symmetric relative w-[30px] h-[30px] flex-center cursor-pointer z-20  transition-300-ease rounded-full backdrop-blur-[10px]
                                                    ${voxelSymmetric && style.geomvoxelSymmetric}
                                                    ${voxelSymmetric ? "bg-[rgba(40,221,232,0.1)]" : "bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.3)]"}
                                                    ${noModel ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"}
                                                    ${style.geomsymmtricBox}`}>
                                                    <img className='w-[14px] h-[14px]' src={voxelSymmetric ? symmetric_active : symmetric_default} alt="symmetric" />
                                                    <div ref={symmetricRef} className='opacity-0 whitespace-nowrap translate-x-[calc(-100%-16px)] pointer-events-none group-hover/symmetric:opacity-100 group-hover/symmetric:pointer-events-auto   group-hover/symmetric:translate-x-[calc(-100%-8px)] transition-300-ease absolute top-0 left-0 leading-[30px] [filter:drop-shadow(0px_0px_6px_rgba(0,0,0,0.2))] [background:rgba(255,255,255,0.1)] h-full px-[6px] rounded-lg before:content-[""] before:absolute before:right-0 before:top-1/2 before:w-0 before:h-0 before:[border:4px_solid_rgba(255,255,255,0.1)] before:[border-left-color:transparent!important] before:[border-bottom-color:transparent!important]  before:[transform:translate(calc(100%-4px),-50%)_rotate(45deg)] before:rounded-[2px]'>{t('THREEWRAPPER_SYMMETRIC')}</div>
                                                </div>
                                            )}
                                        </div>


                                        <div className={`absolute w-[80%]  top-[12px] left-[12px] transition-300-ease flex gap-[8px] items-center
                                            ${showDirectRange && directionIndex >= 1 ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none "}`}>
                                            <DraggableInput
                                                value={sliderValue[directionIndex - 1]}
                                                onChange={handleSliderChange}
                                                onStop={stopRotate}
                                                onDragging={(v) => setRangeDragging(v)}
                                                onUpdated={() => setUpdated(true)}
                                                min={-180}
                                                max={180}
                                                decimalPlaces={0}
                                            />
                                            <div className='w-[90%]'>
                                                <ConditionRange
                                                    styletype="cardpage"
                                                    setRangeDragging={setRangeDragging}
                                                    rangeDragging={rangeDragging}
                                                    openRange={openRange}
                                                    fiexed={0}
                                                    useSticky
                                                    onStop={stopRotate}
                                                    maxRange={180}
                                                    minRange={-180}
                                                    value={sliderValue[directionIndex - 1]}
                                                    onUpdated={() => setUpdated(true)}
                                                    setValue={handleSliderChange} />
                                            </div>

                                        </div>
                                        <div className={`absolute-center text-white flex-center z-[200] w-full h-full bg-[rgba(0,0,0,0.3)] rounded-[16px] transition-300-ease 
                                            ${loading ? "opacity-100 visible" : "opacity-0 invisible"}`}>
                                            <span className="text-white">
                                                {t('THREEWRAPPER_LOADING')}<span className={style.dot}>.</span><span className={style.dot}>.</span><span className={style.dot}>.</span>
                                            </span>
                                        </div>
                                        {(!noModel || activeIndex !== 1) && <BBoxSizeController
                                            meshParameters={meshParameters}
                                            activeIndex={activeIndex}
                                            threeController={threeController}
                                            setDragging={setDragging}
                                            handleOpenSculpt={handleOpenSculpt}
                                            setMeshParameters={setMeshParameters}
                                        />}

                                        {/* <div className={`rounded-[16px] bg-[rgba(0,0,0,0.2)] text-[#fff] flex-center backdrop-blur-[10px] absolute w-full h-full top-0 left-0 transition-300-ease
                                            ${threeController.current?.waitDragModel ? "pointer-events-auto opacity-100" : "opacity-0 pointer-events-none"}`}>
                                            Import 3D Model
                                        </div> */}
                                    </div>
                                    {
                                        openThreeWrapper.status && openThreeWrapper.upload && (
                                            <div className='absolute top-[3px] left-1/2 transform -translate-x-1/2 rounded-[12px] gap-[10px] w-[calc(100%-4px)]  h-fit bg-[#f8f8f8] flex flex-col p-[12px] z-[1000]'>
                                                <div className='font-[700] text-[12px] text-[rgba(18,18,18,1)]'>{t('THREEWRAPPER_CONSTRUCTING') + meshEntryName.filter(item=>item.name===meshValues[activeIndex]?.name?.toLowerCase())[0]?.entryName}</div>
                                                <div className='flex gap-[12px] select-none'>
                                                    <div className={`group/upload h-[132px] w-[132px] p-[6px_10px] cursor-pointer flex items-center justify-start pt-[10px]  flex-col gap-1 rounded-[12px] text-[rgba(172,172,172,1)] transition-300-ease hover:text-[rgba(107,73,179,1)] bg-[#f0f0f0] hover:bg-[rgba(230,221,247,1)] outline-2 outline-none  
                                                ${fileDropHover && openThreeWrapper.upload ? "outline-[rgba(74,0,224,1)] outline-dashed " : "outline-[transparent] hover:outline-[rgba(74,0,224,0.4)] hover:[outline-style:solid]"}
                                                ${style.fileUpload}`}
                                                        onDrop={handleFileDrop}
                                                        onDragOver={handleDragOver}
                                                        onDragEnter={handleDragEnter}
                                                        onDragLeave={handleDragLeave}
                                                        onClick={handle3dconditionUpload}>
                                                        <span className={`text-[12px] font-[700] transition-300-ease group-hover/upload:text-[rgba(74,0,224,1)]`}>{t('THREEWRAPPER_UPLOAD')}</span>
                                                        <div>
                                                            <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path className='transition-300-ease [opacity:0.6] group-hover/upload:[opacity:1]' d="M13.1999 13.4292V16.1231H18.012C19.6962 15.8782 21.0195 14.2863 21.0195 12.4496C21.0195 10.368 19.4556 8.77614 17.4105 8.77614C16.9293 8.77614 16.5684 8.89859 16.2075 9.02103V8.77614C16.2075 6.08226 14.042 3.87818 11.3954 3.87818C8.74881 3.87818 6.5834 6.08226 6.5834 8.77614C6.5834 9.26593 6.7037 9.63328 6.7037 10.1231C6.4631 10.0006 6.22249 10.0006 5.98189 10.0006C4.29768 10.0006 2.97437 11.3476 2.97437 13.0619C2.97437 14.7761 4.29768 16.1231 5.98189 16.1231H10.7939V13.4292L9.47062 14.7761L7.7864 13.0619L11.9969 8.77614L16.2075 13.0619L14.5232 14.7761L13.1999 13.4292ZM13.1999 16.1231V18.5721H10.7939V16.1231H9.59092V18.5721H5.98189C2.97437 18.5721 0.568359 16.1231 0.568359 13.0619C0.568359 10.6129 2.13227 8.53124 4.17738 7.79655C4.65859 4.24553 7.6661 1.4292 11.3954 1.4292C14.5232 1.4292 17.2902 3.51083 18.2526 6.32716C21.1398 6.6945 23.4255 9.26593 23.4255 12.4496C23.4255 15.6333 21.0195 18.2047 18.012 18.5721H14.4029V16.1231H13.1999Z" fill="rgba(153,153,153,1)" />
                                                            </svg>
                                                        </div>
                                                        <span className='text-[10px]'>{t('THREEWRAPPER_UPLOAD_MODEL') + meshEntryName.filter(item=>item.name===meshValues[activeIndex]?.name?.toLowerCase())[0]?.entryName + t('THREEWRAPPER_WATER_MESH_TIP_5')}</span>
                                                    </div>
                                                    <div className={`group/handcraft transition-300-ease h-[132px] w-[132px] p-[6px_10px] cursor-pointer flex items-center justify-start pt-[10px]  outline-none outline-2 hover:outline-[rgba(74,0,224,0.4)] hover:[outline-style:solid] flex-col gap-1 rounded-[12px] text-[rgba(172,172,172,1)] transition-300-ease hover:text-[rgba(107,73,179,1)] bg-[#f0f0f0] hover:bg-[rgba(230,221,247,1)]
                                                    ${style.fileHandcraft}`}
                                                        onClick={handle3dconditionHandcraft}>
                                                        <span className='text-[12px] font-[700] transition-300-ease group-hover/upload:text-[rgba(74,0,224,1)]'>{t('THREEWRAPPER_HANDCRAFT')}</span>
                                                        <div>
                                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path className='transition-300-ease [opacity:0.6] group-hover/handcraft:[opacity:1]' d="M16.7458 18.0423C15.2183 18.9897 13.362 19.2647 11.5831 18.8093L10.6099 18.5579L4.62432 17.0196C3.53936 16.7403 2.84971 15.6274 3.08174 14.5317C3.31377 13.436 4.38155 12.7743 5.46436 13.0536L7.52256 13.5821L5.33545 10.0587L2.82823 6.01746C2.22452 5.04637 2.49092 3.78953 3.4212 3.2116C4.35147 2.63367 5.59541 2.95379 6.19913 3.92488L8.57745 7.75984C8.64834 7.87371 8.79444 7.91238 8.90401 7.84363L13.8776 4.75848C14.9132 4.11394 16.2989 4.47059 16.9692 5.5534L18.7739 8.46023C20.8343 11.7796 19.9255 16.07 16.7458 18.0423Z" fill="rgba(153,153,153,1)" />
                                                            </svg>
                                                        </div>
                                                        <span className='text-[10px]'>{t('THREEWRAPPER_CREATE_MODEL') + meshEntryName.filter(item=>item.name===meshValues[activeIndex]?.name?.toLowerCase())[0]?.entryName + t('THREEWRAPPER_WATER_MESH_TIP_5')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className='flex justify-between items-center w-full  px-[2px] text-xs mt-2'>
                                        <div className='flex gap-2 items-center'>
                                            <div className={`${style['bboxitem-icon']} flex w-[16px] h-[16px] sm:w-[24px] sm:h-[24px]`}>
                                                <img className='w-[60%] h-[60%] m-auto' src={meshValues[activeIndex].icon} alt={meshValues[activeIndex].name} />
                                            </div>
                                            <span className='text-[rgba(18,18,18,1)]'>{meshEntryName.filter(item=>item.name===meshValues[activeIndex].name)[0]?.entryName}</span>
                                        </div>
                                        <button onClick={handleConfirmBoxSize} className={`px-[8px] py-[4px] md:px-[12px] md:py-[4px] bg-[rgba(74,0,224,0.1)] rounded-[16px] text-[rgba(74,0,224,1)] transition-300-ease hover:bg-[rgba(74,0,224,0.05)]
                                            ${openThreeWrapper.status && openThreeWrapper.upload ? "opacity-0 pointer-events-none" : "opacity-100 pointer-events-auto"}`}>{t('THREEWRAPPER_BUTTON_CONFIRM')}</button>
                                    </div>
                                    {activeIndex === 1 && openThreeWrapper.status && !openThreeWrapper.upload && (
                                        <div className='w-full flex flex-col items-center mt-[8px] px-[12px] pb-[8px] text-xs gap-1 text-[rgba(136,136,136,1)] select-none'>
                                            <div className='w-full flex justify-between pt-1 items-center border-t gap-4 border-t-[rgba(237,230,252,1)]'>
                                                <span className='flex flex-row gap-1 items-center'>{t('THREEWRAPPER_SCALE')}<Annotation text={t('THREEWRAPPER_SCALE_TIP')} /></span>
                                                <div className='flex gap-2 items-center w-[125px]  md:w-[190px]'>
                                                    <ConditionRange
                                                        styletype="cardpage"
                                                        openRange={openRange}
                                                        rangeDragging={rangeDragging}
                                                        setRangeDragging={setRangeDragging}
                                                        maxRange={1.00}
                                                        setValue={setVoxelRangeVal}
                                                        fiexed={1}
                                                        value={voxelScale} />
                                                    <span>{voxelScale === 1 ? "1.0" : voxelScale}</span>
                                                </div>
                                            </div>
                                            <div className='w-full flex justify-between items-center'>
                                                <span className='flex flex-row gap-1 items-center'>{t('THREEWRAPPER_MODE')}<Annotation text={t('THREEWRAPPER_MODE_TIP')} /></span>
                                                <div className='bg-[rgba(238,238,238,1)] rounded-[29px] p-[3px] w-[125px]  md:w-[190px] flex justify-between items-center'>
                                                    {MODE_ARRAY.map((item, index) => (
                                                        <span
                                                            className={`transition-300-ease cursor-pointer flex-1 rounded-md text-center
                                                            ${voxelMode === item.params ? "text-[rgba(74,0,224,1)] bg-[rgba(222,215,237,1)]" : "text-[rgba(102,102,102,1)]"}
                                                            ${index === 0 && "rounded-l-[20px]"}
                                                            ${index === 1 && "rounded-r-[20px]"}`}
                                                            key={index}
                                                            onClick={handleSetVoxelCfg.bind(null, item.params)}>{item.name === 'Strict' ? t('THREEWRAPPER_MODE_STRICT') : t('THREEWRAPPER_MODE_ROUGH')}</span>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {activeIndex === 2 && openThreeWrapper.status && !openThreeWrapper.upload && (
                                        <div className='w-full flex flex-col items-center mt-[8px] px-[12px] pb-[8px] text-xs gap-1 text-[rgba(136,136,136,1)] select-none'>
                                            <div className='w-full flex justify-between pt-1 items-center border-t gap-4 border-t-[rgba(237,230,252,1)]'>
                                                <span className='flex flex-row gap-1 items-center'>{t('THREEWRAPPER_UNCERTAINTY')}<Annotation text={t('THREEWRAPPER_UNCERTAINTY_TIP')} /></span>
                                                <div className='flex gap-2 items-center w-[125px]  md:w-[190px]'>
                                                    <ConditionRange
                                                        styletype="cardpage"
                                                        rangeDragging={rangeDragging}
                                                        openRange={openRange}
                                                        setRangeDragging={setRangeDragging}
                                                        maxRange={0.05}
                                                        setValue={setRangeVal}
                                                        value={pcdUncertainty} />
                                                    <span>{pcdUncertainty === 0.01 ? "0.010" : pcdUncertainty}</span>
                                                </div>
                                            </div>
                                            <div className='w-full flex justify-between items-center'>
                                                <span className='flex flex-row gap-1 items-center'>{t('THREEWRAPPER_SAMPLING')}<Annotation text={t('THREEWRAPPER_SAMPLING_TIP')} /></span>
                                                <div className='bg-[rgba(238,238,238,1)] rounded-[29px] p-[3px] w-[125px]  md:w-[190px] flex justify-between items-center'>
                                                    {SAMPLING_ARRAY.map((item, index) => (
                                                        <span
                                                            className={`transition-300-ease cursor-pointer flex-1 rounded-md text-center
                                                            ${samplingVal === index ? "text-[rgba(74,0,224,1)] bg-[rgba(222,215,237,1)]" : "text-[rgba(102,102,102,1)]"}
                                                            ${index === 0 && "rounded-l-[20px]"}
                                                            ${index === 1 && "rounded-r-[20px]"}`}
                                                            key={index}
                                                            onClick={handleSetSampling.bind(null, index)}>{item}</span>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <input ref={fileInputRef} onChange={handleFileInputChange} type="file" id="file-input" accept=".obj,.fbx,.glb,.gltf,.dae,.stl,.ply" style={{ display: 'none' }} />
                                </div>
                            </ThreeJSOverlay>}
                        </div>

                        {!isDone && !openThreeBoxSelector && (
                            <div className='relative h-full flex items-center z-[9999]'>
                                <div className={`h-[50%] w-[1px] bg-[#C8C8C8] absolute left-1 [@media_(min-height:1400px)]:left-0 `}></div>
                                <div onMouseEnter={stage === STAGE_ENUM.GENERATING ? () => { } : setOptionHover.bind(null, true)} onMouseLeave={stage === STAGE_ENUM.GENERATING ? () => { } : setOptionHover.bind(null, false)} id='optionClick' className={`relative ${stage === STAGE_ENUM.GENERATING ? 'cursor-default' : 'cursor-pointer'} h-[90%] p-1 aspect-square flex justify-end items-center`} onClick={() => {
                                    if (stage === STAGE_ENUM.GENERATING) {
                                        return;
                                    }
                                    if (isCreatorOrAbove()) {
                                        if (!optionOpen) {
                                            setOptionOpen(true)
                                        } else {
                                            setOptionOpen(false)
                                        }
                                    } else {
                                        setShowOptSubLinkTip(true)
                                        // setOptionOpen(true)
                                    }
                                }}>
                                    <img className={`h-[75%] z-[-1] [@media_(min-height:1400px)]:h-[85%] aspect-square ${!optionChange && !optionOpen && optionHover && 'animate-option-icon'}`} src={optionChange ? Opcheck : optionOpen ? OpiconIn : optionHover ? Ophover : Opicon} />
                                    <div className={`absolute whitespace-nowrap right-[1px] text-[#FF4E4E] [fontSize:var(--smFs)] -top-[100%] [@media_(min-height:1400px)]:-top-[140%] bg-white [transition:all_0.3s_ease] [box-shadow:0px_3px_6px_1px_rgba(150,_150,_150,_0.35)] px-3 [@media_(min-height:1400px)]:px-5 py-[0.35rem] [@media_(min-height:1400px)]:py-2 rounded-xl ${showOptSubLinkTip ? 'opacity-100 visible' : 'opacity-0 invisible'}
                                before:content-[""] before:absolute before:right-2 before:-bottom-[0.4rem] before:w-2 before:h-2 before:[border-top:7px_solid_white] before:[border-left:5px_solid_transparent] before:[border-right:5px_solid_transparent]`}>
                                        <span>{t('UNLOCK_SUB_TIP1')}<span className='border-b-[1px_solid_#ff4e4e] [transition:color_0.3s_ease,_border-color_0.3s_ease] underline underline-offset-2 hover:text-[#4A00E0] hover:border-[#4A00E0]' onClick={handlerOpenSub}>{t('UNLOCK_SUB_TIP4')}</span></span>
                                    </div>
                                </div>
                                <Option optionChange={optionChange} setOptionChange={setOptionChange} advOption={advOption} setAdvOption={setAdvOption} />
                            </div>
                        )}
                    </div>
                </div>
                <WeightSelector
                    pointerArr={pointerArr}
                    viewWeights={viewWeights}
                    setPointerArr={setPointerArr}
                    onChange={handleWeightChange}
                    disabled={isDone}
                    mode={taskDetail?.settings?.condition_mode}
                    setSelectedDirection={parseSelectedDirection}
                    selectedDirection={selectedDirection}
                    setSelectorHover={setSelectorHover}
                    setDragging={setDirectDragging}
                    dragging={directDragging}
                />
                {!isDone && (
                    <div className={`${style.geometryBtns} ${selectorHover || (directDragging !== false) ? 'pointer-events-none' : 'pointer-events-auto'}`}>
                        {stage !== STAGE_ENUM.GENERATING ? (
                            <>
                                {stage !== STAGE_ENUM.GENERATE && (
                                    <div className={style.redoBtn} onClick={handleRedo} id='RedoTab'>
                                        {redoCount < 5 && (
                                            <div className={style.redoTips}>
                                                <RedoTips />
                                                <div className={style.redoHodler}></div>
                                            </div>
                                        )}
                                        <span>{t('BUTTON_REDO')}</span>
                                        <Restricted to="billing.view">
                                            {remaingShow && (
                                                <span className={style.remaining}>x{redoCount}</span>
                                            )}
                                        </Restricted>
                                    </div>
                                )}
                                <div className={`group ${style.confirmBtn} ${stage === STAGE_ENUM.SYMMETRICAL ? style.change : ''} ${stage !== STAGE_ENUM.GENERATE ? style.credits : ""}`}>
                                    <span id='geoConfirmTab' className='absolute w-[100%] h-[100%] top-0 left-0 pointer-events-none'></span>
                                    {stage === STAGE_ENUM.SYMMETRICAL && (
                                        <span className={style.checkFont}>
                                            <span className={style.checkSpan} style={{ left: check ? 'calc(50% - 3px)' : '3px' }} />
                                            <span className={`${style.no} ${check ? '' : style.checked}`} onMouseEnter={handlerSetCheck.bind(null, false)} onClick={handleConfirmOrGenerate.bind(null, true, false)}>No</span>
                                            <span className={`${style.yes} ${check ? style.checked : ''}`} onMouseEnter={handlerSetCheck.bind(null, true)} onClick={handleConfirmOrGenerate.bind(null, true, true)}>Yes</span>
                                        </span>
                                    )}
                                    {stage !== STAGE_ENUM.SYMMETRICAL && (
                                        <span className={`${style.confirmSpan}`}
                                            onClick={handleConfirmOrGenerate.bind(null, false)}
                                            onMouseEnter={handleShowCredits}
                                            onMouseLeave={handleCloseCredits}>
                                            {stage === STAGE_ENUM.GENERATE ? t('BUTTON_SMALL_GENERATE') : confirmBtnInfo === 'Confirm' ? t('BUTTON_SMALL_GEO_CONFIRM') : confirmBtnInfo}
                                        </span>
                                    )}
                                    {stage !== STAGE_ENUM.GENERATE && (
                                        <div className={`${style.polygonsWrapper}`}>
                                            <div className={`${style.polygonsContent} gap-[var(--smGap)]`}>
                                                <div className={`${currentPolygonsIndex !== -2 ? style.checkhover : ''} gap-[var(--smGap)] w-full h-auto flex flex-row justify-between`}>
                                                    <div className='w-[21%] [@media_(min-height:1080px)]:w-[24%] h-auto aspect-square bg-[rgb(238,238,238)] rounded-[12px] overflow-hidden'>
                                                        <img className='w-full' src={rawcheckIcon} />
                                                    </div>
                                                    <div onClick={(e) => handlerChoosePolygons(e, -2)} className={`group/raw [contain:layout] overflow-hidden relative flex flex-col items-start justify-between w-[76%] h-auto py-[2.5%] px-[4%] border-[1px] border-solid rounded-[12px] [transition:border-color_0.3s_ease]
                                                    ${currentPolygonsIndex === -2 ? 'border-[#7B42F6] text-[rgb(123,66,246)] bg-[rgb(246,242,255)]' : 'border-transparent text-[#8C8C8C] hover:text-[rgb(123,66,246)] hover:border-[#7B42F6] bg-[rgb(246,246,246)] hover:bg-[rgb(246,242,255)]'}`}>
                                                        <div className={`absolute flex items-center justify-center pointer-events-none z-[999] h-[100%] left-0 top-0 bg-[rgba(255,255,255,0.4)] [clip-path:polygon(50%_0,100%_0,50%_100%,0_100%)] opacity-0 group-hover:opacity-100 group-hover:animate-geo-raw `}></div>
                                                        <div className='w-full [contain:layout] h-auto flex flex-row items-center justify-between'>
                                                            <span className='text-[var(-midFs)] leading-[var(-midFs)]'>{t('RODIN_PRO_MODE')}</span>
                                                            <label onClick={handleSimplify} className={`cursor-pointer h-full flex flex-row items-center gap-[2px] [transition:opacity_0.3s_ease] [font-size:var(--smFs)] leading-[var(--smFs)] [@media_(max-height:1080px)]:[font-size:11px] [@media_(max-height:1080px)]:leading-[11px] font-normal`} >
                                                                <span className={`${style.checkmark} ${currentPolygonsIndex === -2 && style.current} ${simplifyCheck ? style.checked : ''} ${currentPolygonsIndex !== -2 ? style.prechecked : ''}`}></span>
                                                                <span className='flex items-center gap-[1px] relative'>{t('RODIN_PRO_SIMPLIFY')}</span>
                                                            </label>
                                                        </div>
                                                        <div className={`w-full [contain:layout] flex items-center justify-between`}>
                                                            <div
                                                                className={`font-normal whitespace-nowrap [font-size:var(--smFs)] leading-[var(--smFs)] text-left [font-style:normal] normal-case select-none flex items-center gap-[5px] [transition:border-color_0.3s_ease]`}>
                                                                <div className={`w-[12px] h-[12px] rounded-full [transition:border-color_0.3s_ease] flex items-center justify-center relative
                                                                ${currentPolygonsIndex === -2 ? '[border:1px_solid_#7B42F6]' : '[border:1px_solid_#8C8C8C] group-hover/raw:[border:1px_solid_#7B42F6]'}`}>
                                                                    <span className={`w-full h-full rounded-full [border:1px_solid_rgb(246,242,255)] [transition:border-color_0.3s_ease]
                                                                    ${rawCheck ? 'opacity-100 visible' : 'opacity-0 invisible'}
                                                                    ${rawCheck ? (currentPolygonsIndex !== -2 ? 'bg-[#808080] group-hover/raw:bg-[rgb(123,66,246)]' : `bg-[rgb(123,66,246)]`) : ''}`}></span>
                                                                </div>
                                                                {t('RODIN_PRO_TIP')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div onClick={(e) => {
                                                    if (currentPolygonsIndex === -2) {
                                                        handlerChoosePolygons(e, prePolygonsIndex)
                                                    }
                                                }} className={`${currentPolygonsIndex === -2 ? style.checkhover : ''} gap-[var(--smGap)]  w-full h-auto flex flex-row justify-between`}>
                                                    <div className='w-[21%] [@media_(min-height:1080px)]:w-[24%] bg-[rgb(238,238,238)] rounded-[12px] overflow-hidden'>
                                                        <img className='w-full' src={meshcheckIcon} />
                                                    </div>
                                                    <div className={`group/quad [contain:layout] flex flex-col items-start justify-between w-[76%] h-auto py-[2.5%] px-[4%]  border-[1px] border-solid rounded-[12px] [transition:border-color_0.3s_ease]
                                                    ${currentPolygonsIndex !== false && currentPolygonsIndex >= 0 ? 'border-[#7B42F6] text-[rgb(123,66,246)] bg-[rgb(246,242,255)]' : 'border-transparent text-[#8C8C8C] hover:text-[rgb(123,66,246)] hover:border-[#7B42F6] bg-[rgb(246,246,246)] hover:bg-[rgb(246,242,255)]'}`}>
                                                        <div className='w-full [contain:layout] h-auto flex flex-row items-center justify-between'>
                                                            <span className='text-[var(-midFs)] leading-[var(-midFs)]'>{t('RODIN_QUAD_MESH')}</span>
                                                            <label className={`cursor-pointer relative flex flex-row items-center gap-[2px] [transition:opacity_0.3s_ease] [font-size:var(--smFs)] leading-[var(--smFs)] [@media_(max-height:1080px)]:[font-size:11px] [@media_(max-height:1080px)]:leading-[11px] font-normal`} onMouseEnter={setOpenQuadSwitch.bind(null, true)}>
                                                                <div
                                                                    className={`relative mr-[2px] flex h-[12px] w-[12px] items-center justify-center rounded-[4px] bg-[rgb(230,219,255)] [transition:all_0.2s_ease] ${openQuadSwitch ? 'pointer-events-none opacity-0' : 'pointer-events-auto opacity-100'}`}
                                                                >
                                                                    <img
                                                                        alt="quadswitch"
                                                                        className="h-auto w-[60%]"
                                                                        src={
                                                                            quadswitchIcon
                                                                        }
                                                                    />
                                                                </div>
                                                                <div
                                                                    className="flex flex-row items-center gap-[2px]"
                                                                    onClick={
                                                                        handleSmooth
                                                                    }
                                                                >
                                                                    <span className={`${style.checkmark} ${currentPolygonsIndex !== -2 && style.current} ${smoothCheck ? style.checked : ''} ${currentPolygonsIndex === -2 ? style.prechecked : ''}`}></span>
                                                                    <span className='flex items-center gap-[1px] relative'>{t('RODIN_QUAD_SMOOTH')}</span>
                                                                </div>
                                                                <div
                                                                className={`absolute -top-[8px] left-[7px] z-[999] flex h-auto w-auto flex-col gap-[6px] rounded-[8px] bg-white px-[9px] py-[8px] [box-shadow:0px_0px_10px_0px_#7B42F63E] [transition:opacity_0.2s_ease] before:absolute before:left-0 before:top-0 before:h-full before:w-[10px] before:-translate-x-[100%] ${openQuadSwitch ? 'visible opacity-100' : 'invisible opacity-0'}`}
                                                                onMouseLeave={setOpenQuadSwitch.bind(null, false)}>
                                                                    <div
                                                                        className="relative flex flex-row items-center gap-[2px]"
                                                                        onClick={
                                                                            handleSmooth
                                                                        }
                                                                    >
                                                                        <span
                                                                            className={`${style.checkmark} ${style.current} ${smoothCheck ? style.checked : ''}`}
                                                                        ></span>
                                                                        <span className="relative flex items-center gap-[1px]">
                                                                            {t(
                                                                                'RODIN_QUAD_SMOOTH'
                                                                            )}
                                                                        </span>
                                                                        <div className="relative">
                                                                            <Annotation
                                                                                text={t(
                                                                                    'RODIN_GENERATE_BOARD_GEO_SMOOTH_TIP'
                                                                                )}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="flex flex-row items-center gap-[2px]"
                                                                        onClick={
                                                                            handleAsymmetry
                                                                        }
                                                                    >
                                                                        <span
                                                                            className={`${style.checkmark} ${style.current} ${asymmetryCheck ? style.checked : ''}`}
                                                                        ></span>
                                                                        <span className="relative flex items-center gap-[1px] whitespace-nowrap">
                                                                            {t(
                                                                                'RODIN_QUAD_FORCED_ASYMMETRY'
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div className={`relative z-[-1] w-full [contain:layout] flex items-center justify-between`}>
                                                            {[4000, 8000, 18000, 50000].map((item, index) => {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className={`font-normal flex-grow relative [font-size:var(--smFs)] leading-[var(--smFs)] [font-style:normal] gap-[3%] normal-case select-none flex items-center [transition:border-color_0.3s_ease]
                                                                        ${currentPolygonsIndex && currentPolygonsIndex >= 0 ? 'text-[rgb(123,66,246)]' : ''}
                                                                        ${index === 0 ? 'justify-start' : index === 3 ? 'justify-end' : 'justify-center'}`}
                                                                        onClick={(e) => { handlerChoosePolygons(e, index) }}>
                                                                        {!subscriptionsInfo.plan_level && index !== 2 && <div onClick={() => setShowSubscribe(true)} className={`absolute flex items-center justify-center whitespace-nowrap right-[1px] bottom-0 -translate-y-[100%] text-[#FF4E4E] [fontSize:var(--smFs)] bg-white [transition:all_0.3s_ease] [box-shadow:0px_3px_6px_1px_rgba(150,_150,_150,_0.35)] px-3 py-1 rounded-xl
                                                                        ${showSubLinkTip === index ? 'opacity-100 visible' : 'opacity-0 invisible'}
                                                                        before:content-[""] before:absolute before:right-2 before:-bottom-[0.4rem] before:w-2 before:h-2 before:[border-top:7px_solid_white] before:[border-left:5px_solid_transparent] before:[border-right:5px_solid_transparent]`}>
                                                                            <span>{t('UNLOCK_SUB_TIP1')}<span className='border-b-[1px_solid_#ff4e4e] [transition:color_0.3s_ease,_border-color_0.3s_ease] underline underline-offset-2 hover:text-[#4A00E0] hover:border-[#4A00E0]' >{t('UNLOCK_SUB_TIP2')}</span></span>
                                                                        </div>}
                                                                        <div className={`w-[12px] h-[12px] rounded-full [transition:border-color_0.3s_ease] flex items-center justify-center relative
                                                                        ${currentPolygonsIndex !== false && currentPolygonsIndex >= 0 ? '[border:1px_solid_#7B42F6]' : '[border:1px_solid_#8C8C8C] group-hover/quad:[border:1px_solid_#7B42F6]'}`}>
                                                                            <span className={`w-full h-full rounded-full [border:1px_solid_rgb(246,242,255)] [transition:background_0.3s_ease,opacity_0.3s_ease]
                                                                            ${(currentPolygonsIndex === index && currentPolygonsIndex !== -2) ? 'opacity-100 visible' : `${(prePolygonsIndex === index && currentPolygonsIndex === -2) ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                                                                            ${currentPolygonsIndex === -2 ? 'bg-[#808080] group-hover/quad:bg-[rgb(123,66,246)]' : `bg-[rgb(123,66,246)]  `}`}></span>
                                                                        </div>
                                                                        <span>{item}</span>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>


                                                {/* <div className={`${style.contentBottom} `}>
                                                    {[4000, 8000, 18000, 50000].map((item, index) => {
                                                        return (
                                                            <div
                                                                key={index}
                                                                className={`${style.polygonsItem} ${currentPolygonsIndex === index ? style.selected : ""}  ${!isCreatorOrAbove() ? style.generalUser : ""}`}
                                                                onClick={handlerChoosePolygons.bind(null, index)}>
                                                                <div className={style.checkBoxIcon}>
                                                                    <span></span>
                                                                </div>
                                                                {item}
                                                            </div>
                                                        )
                                                    })}
                                                </div> */}
                                            </div>
                                            <div className={style.polygonSpaceHodler}></div>
                                        </div>
                                    )}
                                    {stage === STAGE_ENUM.CHANGED_CONFIRM && (
                                        <ChangeConfirmTip handleRedo={handleRedo}
                                            setStage={setStage} />
                                    )}
                                    {stage === STAGE_ENUM.SYMMETRICAL && (
                                        <SymmetricalTip imgUrl={currentPreviewImage} />
                                    )}
                                </div>
                            </>
                        ) : (
                            <WaitingProgress percentage={generatePercentage} queue={isQueued} />
                        )}

                    </div>
                )}
            </div>
        </div>
    )
})

const BBoxSizeController = ({ meshParameters, threeController, setMeshParameters, dragging, setDragging, activeIndex }) => {
    const [inputFocusedByClick, setInputFocusedByClick] = useState(false)
    const [isFocused, setIsFocused] = useState(false);
    const isChangedRef = useRef(false)
    const keyMap = ['bbox', 'voxel', 'pointCloud']
    const valueMap = ['pos', 'wlhparams', 'wlhparams']
    const isComposingRef = useRef(false);
    const { t } = useTranslation();
    const tip = useTips()

    const validateInput = (value) => {
        // 允许空输入、数字、一个小数点，以及末尾的小数点
        return /^(\d*\.?\d*|\d+\.)$/.test(value);
    };

    const transformInput = (axis, value) => {
        let numberValue = parseFloat(value);
        if (isNaN(numberValue)) return null;

        if (keyMap[activeIndex] === 'bbox') {
            numberValue = Math.max(1, Math.min(300, numberValue));
        }
        return Math.round(numberValue * 100) / 100;
    };

    const handleInput = (axis, e) => {
        if (isComposingRef.current) return;
        const value = e.target.value;

        if (validateInput(value)) {
            e.target.value = value;
            e.target.dataset.lastValidValue = value;

            // 对于非bbox情况，允许输入任何数字和小数点
            if (keyMap[activeIndex] !== 'bbox') {
                changeWLH(axis, value);
                let numberValue = parseFloat(value);

                // 只有当输入是一个完整的数字时才进行范围检查和更新
                if (!isNaN(numberValue) && /^-?\d+(\.\d+)?$/.test(value)) {
                    if (numberValue < 0.1 || numberValue > 3) {
                        tip({
                            content: t('TIP_WRAN_SIZE_LIMIT'),
                            type: 'warning',
                        });
                    } else {
                        const transformedValue = Math.round(numberValue * 100) / 100;
                        e.target.value = transformedValue;
                        changeWLH(axis, transformedValue);
                        updateThreeController(axis, transformedValue);
                    }
                }
            } else {
                // 对于bbox情况，保持原有逻辑
                if (/^-?\d+(\.\d+)?$/.test(value)) {
                    const transformedValue = transformInput(axis, value);
                    if (transformedValue !== null) {
                        changeWLH(axis, transformedValue);
                        updateThreeController(axis, transformedValue);
                    }
                }
            }
        } else {
            // 如果输入不合法，恢复到上一个有效值
            e.target.value = e.target.dataset.lastValidValue || '';
        }
    };
    const handleCompositionStart = () => {
        isComposingRef.current = true;
    }

    const handleCompositionEnd = (axis, event) => {
        isComposingRef.current = false;
        const value = event.target.value;
        validateInput(value);
    }

    const changeWLH = (axis, newValue) => {
        setMeshParameters(prev => ({
            ...prev,
            [keyMap[activeIndex]]: {
                ...prev[keyMap[activeIndex]],
                [valueMap[activeIndex]]: {
                    ...prev[keyMap[activeIndex]][valueMap[activeIndex]],
                    [axis.toLowerCase()]: newValue
                }
            }
        }));
    }

    const updateThreeController = async (axis, value) => {
        const newValueMap = { ...meshParameters[keyMap[activeIndex]][valueMap[activeIndex]], [axis?.toLowerCase()]: value };
        threeController.current.boundingBox.updateWHLOrScaleMesh(newValueMap, keyMap[activeIndex]);
        await threeController.current.updateMeshByScale(keyMap[activeIndex]);
    }

    const handleMouseDown = (axis, e) => {
        if (isFocused) return
        if (threeController.current.isAnimation) return
        setDragging(true)
        const startX = e.clientX;
        const currentValue = meshParameters[keyMap[activeIndex]][valueMap[activeIndex]][axis?.toLowerCase()];
        document.onmousemove = (e) => {
            isChangedRef.current = true;
            const endX = e.clientX;
            const diff = endX - startX;
            let newValue;
            if (keyMap[activeIndex] === 'bbox') {
                newValue = Math.floor(Math.max(1, Math.min(300, currentValue + diff / 5)));
            } else {
                newValue = Math.max(0.1, Math.min(3, currentValue + (diff / 50)));
                newValue = Number(formatNum(newValue))
            }
            changeWLH(axis, newValue)
            const newValueMap = { ...meshParameters[keyMap[activeIndex]][valueMap[activeIndex]], [axis?.toLowerCase()]: newValue }
            threeController.current.boundingBox.updateWHLOrScaleMesh(newValueMap, keyMap[activeIndex]);
        }
        document.onmouseup = async () => {
            document.onmousemove = null;
            document.onmouseup = null;
            setTimeout(() => {
                setDragging(false)
            }, 100);
            if (!isChangedRef.current) return
            isChangedRef.current = false
            if (!isFocused) {
                await threeController.current.updateMeshByScale(keyMap[activeIndex])
            }
        }
    };

    const formatNum = (num) => {
        let value = Math.round(parseFloat(num) * 100) / 100;
        let arrayNum = value.toString().split(".");
        if (arrayNum.length == 1) {
            return value.toString() + ".00";
        }
        if (arrayNum.length > 1) {
            if (arrayNum[1].length < 2) {
                return value.toString() + "0";
            }
            return value;
        }
    }

    const handleInputMouseDown = (e) => {
        if (isFocused) return
        e.preventDefault();
        setInputFocusedByClick(true)
    }

    const handleInputClick = (e) => {
        if (inputFocusedByClick) {
            e.target.focus();
            setInputFocusedByClick(false)
        }
    }

    const handleFocus = () => {
        setIsFocused(true)
    }

    const handleBlur = () => {
        setIsFocused(false)
    }
    return (
        <div className='absolute select-none py-2 bottom-0 w-full flex justify-center items-center gap-2'>
            {Object.entries(meshParameters[keyMap[activeIndex]][valueMap[activeIndex]]).map((param) => (
                <React.Fragment key={param[0]}>
                    <div onMouseDown={handleMouseDown.bind(null, param[0])} className='w-[22%] justify-between bg-[rgba(0,0,0,0.2)] text-screen-sm px-2 py-1 flex items-center rounded-[6px] border border-transparent transition-300-ease hover:border-[rgba(255,255,255,0.5)]'>
                        <label className=' cursor-ew-resize   text-[rgba(255,255,255,0.5)]'>{directionMap[param[0]].toUpperCase()}</label>
                        <input
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            onMouseDown={handleInputMouseDown}
                            onClick={handleInputClick}
                            onInput={(e) => handleInput(param[0], e)}
                            onCompositionStart={handleCompositionStart}
                            onCompositionEnd={(e) => handleCompositionEnd(param[0], e)}
                            className={`w-[35px] pl-[4px] text-white text-center select-none ${style.bboxinput}`}
                            value={param[1]}
                            type="text" />
                    </div>
                    {param[0] !== 'z' && <span className='text-[rgba(255,255,255,0.2)]'>x</span>}
                </React.Fragment>
            ))}
            {/* {activeIndex >= 1 && (
                <div onClick={handleOpenSculpt} className='group/sculpt relative w-[30px] h-[30px] cursor-pointer bg-[rgba(255,255,255,0.1)] flex-center backdrop-blur-[10px] hover:bg-[rgba(255,255,255,0.3)] transition-300-ease rounded-full'>
                    <img className='w-[50%] h-auto' src={sculptIcon} alt="sculpt" />
                    <div className='absolute top-0 right-0 [transform:translate(0,calc(-100%-10px))]  text-[12px] z-10 text-black w-max p-1 px-2 rounded-md bg-[rgba(255,255,255,1)] backdrop-blur-[10px] opacity-0 pointer-events-none transition-300-ease group-hover/sculpt:opacity-100 group-hover/sculpt:pointer-events-auto'>Refine in the editor</div>
                </div>)} */}
        </div>
    )
}


GeometryGeneration.displayName = 'GeometryGeneration'
export default GeometryGeneration